import { SupportedLanguage } from './posTranslations';

export const universalTranslations: Record<SupportedLanguage, Record<string, string>> = {
  ar: {
    // Brand
    brandTitle: 'نظام إدارة التجارة (Trading ERP)',
    brandSub: 'منظومة سحابية متكاملة للمبيعات والمخزون والفوترة',

    // Navigation
    navDashboard: 'لوحة التحكم',
    navCustomers: 'العملاء',
    navLeads: 'الفرص البيعية (Leads)',
    navInventory: 'المخزون والمنتجات',
    navSuppliers: 'الموردين',
    navQuotations: 'عروض الأسعار',
    navDeliveryNotes: 'سندات التسليم',
    navInvoices: 'الفواتير والمدفوعات',
    navQuickPos: 'نقطة البيع السريعة (كاشير)',
    navVendorsHub: 'إدارة المتاجر والشركاء (Vendors Hub)',
    navAccounting: 'المحاسبة والمالية',
    navGovernance: 'الحوكمة المؤسسية',
    navProcurement: 'المشتريات والتوريد',
    navProfitSharing: 'مشاركة الأرباح',
    navHr: 'الموارد البشرية والرواتب (HR)',
    descHr: 'إدارة صلاحيات الموظفين، عقود الرواتب، واحتساب التأمينات (GOSI)',
    navProcessFlow: 'مسار العمليات الذكي',
    navSettings: 'الإعدادات العامة',
    navGlobalAdmin: 'الإدارة العليا (Global Admin)',

    // Header & User Menu
    userProfile: 'الملف الشخصي',
    userSettings: 'إعدادات النظام',
    userLogout: 'تسجيل الخروج',
    loggedOutTitle: 'تم تسجيل الخروج',
    loggedOutDesc: 'تم إنهاء الجلسة بنجاح، نراك قريباً',
    languageSelector: 'اللغة',
    selectLanguage: 'اختر لغة النظام',
    activeVendor: 'المتجر النشط',
    switchVendor: 'تبديل المتجر',
    quickActionPos: 'فتح الكاشير',

    // Common Buttons & Actions
    search: 'بحث...',
    filter: 'تصفية',
    exportCsv: 'تصدير CSV',
    addNew: '+ إضافة جديد',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    actions: 'إجراءات',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'معلق / غير نشط',
    total: 'الإجمالي',
    loading: 'جاري التحميل...',
    back: 'رجوع',
    confirm: 'تأكيد',
    refresh: 'تحديث',
    print: 'طباعة',
    all: 'الكل',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'لوحة التحكم المركزية',
    dashWelcome: 'مرحباً بك في نظام Trading ERP المتكامل',
    totalCustomers: 'إجمالي العملاء',
    activeLeads: 'الفرص البيعية النشطة',
    inventoryItems: 'أصناف المخزون',
    quotations: 'عروض الأسعار',
    monthlyRevenue: 'الإيراد الشهري',
    growthRate: 'معدل النمو',
    totalProfit: 'إجمالي الأرباح',
    pendingProfit: 'الأرباح المعلقة',
    saudiSponsor: 'الكفيل السعودي',
    recentActivity: 'النشاط الأخير',
    quickActions: 'إجراءات سريعة',
    createNewCustomer: 'تسجيل عميل جديد',
    addNewLead: 'إضافة فرصة بيعية',
    generateQuotation: 'إنشاء عرض سعر',
    updateInventory: 'تحديث المخزون',
    activeProcesses: 'العمليات النشطة',
    completedToday: 'المكتملة اليوم',
    pendingActions: 'إجراءات معلقة',
    aiRecommendations: 'توصيات الذكاء الاصطناعي',

    // Vendors Hub
    vendorsTitle: 'إدارة المتاجر والشركاء',
    vendorsSub: 'لوحة الإدارة المركزية لمتابعة جميع المتاجر المسجلة، المنتجات، والوصول الفوري لنقاط البيع POS',
    registerNewVendor: 'تسجيل متجر جديد',
    exportDirectoryCsv: 'تصدير الدليل (CSV)',
    totalRegisteredVendors: 'إجمالي المتاجر المسجلة',
    activeStores: 'المتاجر النشطة',
    catalogedItems: 'أصناف الكتالوج المعروضة',
    businessSectors: 'الأنشطة والقطاعات',
    searchVendorsPlaceholder: 'ابحث باسم المتجر، المالك، الجوال، السجل التجاري، الرقم الضريبي...',
    allSectors: 'جميع الأنشطة',
    allStatuses: 'جميع الحالات',
    activeStatus: 'نشط ويعمل',
    suspendedStatus: 'معلق / متوقف',
    colStoreOwner: 'المتجر والمالك',
    colSectorTax: 'النشاط والضريبة',
    colContact: 'بيانات التواصل',
    colCatalog: 'الكتالوج',
    colStatus: 'الحالة',
    colActions: 'إجراءات',
    openStorePos: 'فتح كاشير المتجر (POS)',
    manageProducts: 'إدارة المنتجات والأصناف',
    editStoreDetails: 'تعديل بيانات المتجر',
    resetPassword: 'إعادة تعيين كلمة المرور',
    suspendStore: 'تجميد المتجر',
    activateStore: 'تفعيل المتجر',
    deleteStore: 'حذف المتجر',

    // Customers
    customersTitle: 'إدارة العملاء',
    customersSub: 'قائمة العملاء وبيانات الاتصال والتقييم الائتماني',
    addCustomerBtn: '+ إضافة عميل جديد',
    searchCustomersPlaceholder: 'ابحث بالاسم، الشركة، أو البريد الإلكتروني...',
    colCustomerName: 'اسم العميل / الشركة',
    colType: 'النوع',
    colContactPerson: 'المسؤول',
    colEmail: 'البريد',
    colPhone: 'الجوال',
    colCreditLimit: 'الحد الائتماني',
    colReliability: 'الموثوقية',
    businessType: 'شركة',
    individualType: 'فرد',

    // Inventory
    invTitle: 'إدارة المخزون والمنتجات',
    invSub: 'تتبع كميات المنتجات والأسعار والتكلفة والموردين',
    addItemBtn: '+ صنف جديد',
    bulkImportBtn: 'استيراد جماعي (CSV)',
    bulkExportBtn: 'تصدير المخزون',
    searchInvPlaceholder: 'ابحث بالاسم، الكود، الباركود، أو التصنيف...',
    colItemName: 'اسم الصنف',
    colSku: 'الباركود / SKU',
    colCategory: 'التصنيف',
    colStock: 'المتوفر',
    colCostPrice: 'سعر التكلفة',
    colSellingPrice: 'سعر البيع',
    colMargin: 'الهامش',
    colSupplier: 'المورد',
    inStock: 'متوفر',
    lowStock: 'منخفض',
    outOfStock: 'نفد المخزون',

    // POS Categories
    catAll: 'الكل',
    catBeverages: 'مشروبات',
    catFood: 'مأكولات',
    catServices: 'خدمات',
    catGeneral: 'عام',

    // Payment & Store
    cardPayment: 'مدى / بطاقة',
    cashPayment: 'نقدي',
    vatShort: 'ضريبة',
    crShort: 'س.ت',
    cashier: 'الكاشير',
    registeredStoreDetails: 'بيانات المتجر المسجل',
    ownerCashier: 'المالك / الكاشير',
    currencyLabel: 'العملة',
    itemsUnit: 'صنف',
    storeNameLabel: 'اسم المتجر',
    ownerNameLabel: 'المالك',
    mobileLabel: 'الجوال',
    categoryLabel: 'النشاط',
    quickAddTooltip: 'إضافة صنف سريع للبيع الفوري',
    bulkCsvTooltip: 'إضافة أصناف بالجملة عبر ملف CSV أو إكسل',
    storeProductsTooltip: 'إدارة قائمة منتجات المتجر',

    // Vendor Catalog
    vendorCatalogTitle: 'كتالوج وإدارة أصناف المتجر',
    vendorCatalogSub: 'أضف وعدل الأصناف والأسعار لتظهر فوراً في شاشة الكاشير السريعة',
    goToPosBtn: 'فتح الكاشير (POS)',
    bulkCsvBtn: 'استيراد بالجملة (CSV)',
    addNewProductBtn: 'صنف جديد',
    searchProductPlaceholder: 'ابحث بالاسم أو الباركود...',
    allCategoriesOpt: 'جميع التصنيفات',
    displayedCount: 'الأصناف المعروضة',
    colVatPrice: 'السعر شامل الضريبة',
    noProductsInCatalog: 'لم يتم العثور على أصناف',
    addFirstProductPrompt: 'أضف أول صنف لمتجرك',
    editProductModalTitle: 'تعديل بيانات الصنف',
    saveChangesBtn: 'حفظ التعديلات',
    cancelBtn: 'إلغاء',

    // Vendor Management Filters & Options
    activeOnly: 'النشطة فقط',
    suspendedOnly: 'الموقوفة مؤقتاً',
    whatsappTooltip: 'محادثة واتساب سريعة',
    launchPosBtn: 'فتح نقطة البيع (POS)',
    manageCatalogBtn: 'إدارة كتالوج المنتجات',
    editStoreBtn: 'تعديل بيانات المتجر',
    changePasswordBtn: 'تغيير كلمة المرور',
    suspendStoreBtn: 'إيقاف المتجر مؤقتاً',
    activateStoreBtn: 'تنشيط المتجر',
    deleteStoreBtn: 'حذف المتجر نهائياً',
    noVendorsFound: 'لم يتم العثور على أي متجر يطابق معايير البحث',
    noVendorsSub: 'يمكنك إضافة متجر جديد أو مسح فلاتر البحث',

    // Vendor Registration & Modal
    registerVendorTitle: 'تسجيل متجر جديد',
    registerVendorSub: 'أضف متجراً جديداً مع تفعيل حسابه الفوري ونقطة البيع ZATCA',
    storeArabicName: 'اسم المتجر بالعربي',
    ownerManagerName: 'اسم المالك / المدير',
    mobileUsername: 'رقم الجوال (اسم المستخدم)',
    emailOptional: 'البريد الإلكتروني (اختياري)',
    initialPassword: 'كلمة المرور الابتدائية',
    businessSector: 'قطاع / نشاط المتجر',
    vatNumber15: 'الرقم الضريبي (15 رقم)',
    crNumber: 'رقم السجل التجاري',
    saveRegisterVendor: 'حفظ وتسجيل المتجر',
    editVendorTitle: 'تعديل بيانات المتجر',
    editVendorSub: 'تحديث بيانات الاتصال والضرائب والسجل التجاري',
    resetPasswordTitle: 'تعيين كلمة مرور جديدة',
    newPasswordLabel: 'كلمة المرور الجديدة',
    updatePasswordBtn: 'تحديث كلمة المرور',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'إضافة صنف سريع',
    quickAddSub: 'سيظهر الصنف مباشرة في شاشة الكاشير للبيع الفوري',
    productArabicName: 'اسم الصنف بالعربي',
    productEnglishName: 'اسم الصنف بالإنجليزي',
    priceVatIncl: 'السعر شامل الضريبة',
    barcodeOptional: 'الباركود / SKU (اختياري)',
    productCategory: 'التصنيف',
    customCategoryOpt: '➕ تصنيف جديد...',
    saveToPosBtn: 'حفظ وإضافة للكاشير',
    bulkImportTitle: 'إضافة أصناف بالجملة (CSV)',
    downloadSampleCsvBtn: 'تحميل نموذج CSV',
    pasteCsvOrExcel: 'الصق أسطر CSV أو انسخ من ملف Excel لإضافة عشرات الأصناف دفعة واحدة',
    csvDataLabel: 'بيانات الأصناف (CSV format)',
    uploadingProducts: 'جاري رفع الأصناف...',
    supportedColumnsTip: 'الأعمدة المدعومة (10 أعمدة كاملة أو 5 أعمدة سريعة):',
    supportedColumnsList: '1. الاسم بالعربي • 2. الاسم بالإنجليزي • 3. سعر البيع • 4. سعر التكلفة • 5. التصنيف • 6. الباركود • 7. الكمية • 8. الوحدة • 9. نسبة الضريبة % • 10. الحد الأدنى',
    bulkImportTip: '💡 يدعم النظام النسخ واللصق المباشر من Excel أو تحميل نموذج CSV الجاهز والمتوافق 100% مع اللغة العربية.',
    importAllProductsNow: 'استيراد كافة الأصناف الآن',
    deleteProductConfirm: 'هل أنت متأكد من حذف هذا الصنف؟',
    itemUnitPiece: 'حبة',

    // Language setting label
    langSettingTitle: 'لغة النظام والتطبيق (Universal Language)',
    langSettingDesc: 'اختر اللغة الافتراضية لكافة شاشات النظام ونقاط البيع ولوحات التحكم',

    // Enterprise Operations Hub & Tiles
    hubSearchPlaceholder: 'ابحث في كافة الأنظمة والعمليات (مثال: عروض أسعار، فواتير، مشتريات)...',
    hubSubtitle: 'منظومة إدارة المؤسسة والعمليات الشاملة',
    hubQuickStats: 'نظرة عامة على الأداء والمؤشرات الرئيسية',
    hubCatAll: 'كافة الأنظمة',
    catSales: 'المبيعات والعملاء',
    catSupply: 'سلاسل الإمداد والمشتريات',
    catRetail: 'نقاط البيع والمتاجر',
    catFinance: 'المالية والحوكمة',
    catSystem: 'العمليات وإدارة النظام',
    openModule: 'دخول النظام',
    backToDashboard: 'العودة إلى لوحة التحكم',
    viewAllRecords: 'عرض السجلات',
    badgeLive: 'نشط',
    systemStatus: 'النظام يعمل بكفاءة',
    quickShortcuts: 'روابط سريعة',
    filterByCategory: 'تصنيف الأنظمة',

    // Module Descriptions
    descCustomers: 'إدارة حسابات العملاء، سجلات التواصل، والحدود الائتمانية',
    descLeads: 'متابعة الفرص البيعية، مراحل الصفقات، ومعدلات التحويل',
    descQuotations: 'إعداد عروض الأسعار الرسمية، ترقيم البنود، ومتابعة الاعتمادات',
    descDeliveryNotes: 'إصدار سندات التسليم، تتبع الإرساليات، وجداول التوريد',
    descInvoices: 'إصدار الفواتير الضريبية الإلكترونية المعتمدة ومتابعة التحصيل',
    descProcurement: 'إدارة طلبات الشراء (PR)، أوامر الشراء (PO)، ومحاضر الاستلام',
    descSuppliers: 'دليل الموردين المعتمدين، السجلات التجارية، وتقييم الأداء',
    descInventory: 'إدارة المخزون والأصناف، تنبيهات النواقص، وحركات المستودع',
    descQuickPos: 'كاشير سريع، مسح الباركود، وطباعة فواتير ZATCA الفورية',
    descVendorsHub: 'إدارة شبكة المتاجر الشريكة، الفروع، وإعدادات المنافذ',
    descAccounting: 'شجرة الحسابات، قيود اليومية، ميزان المراجعة، ودفتر الأستاذ',
    descGovernance: 'محاضر مجلس الإدارة، القرارات، سجل المساهمين، والامتثال',
    descProfitSharing: 'توزيع الأرباح الصافية، حصص الشركاء، وحساب الكفيل',
    descProcessFlow: 'مسارات العمل الذكية، تتبع تسلسل العمليات، والتنبيهات',
    descSettings: 'بيانات المنشأة، الربط مع هيئة الزكاة والضريبة، والإعدادات',
    descGlobalAdmin: 'إدارة المنظومة الشاملة، المنشآت المتعددة، وصلاحيات النظام',

    // HR & Workforce
    hrTitle: "الموارد البشرية والرواتب (HR)",
    hrSub: "إدارة صلاحيات النظام المقيدة للموظفين، عقود الرواتب واحتساب التأمينات (GOSI)، وموافقات الواتساب لأصحاب المصلحة",
    hrKsaComplianceBadge: "نظام العمل السعودي وحماية الأجور (WPS)",
    manageWhatsAppApprovers: "إدارة معتمدي الواتساب",
    addNewEmployee: "إضافة موظف جديد",
    totalWorkforce: "إجمالي القوى العاملة",
    saudizationRate: "نسبة التوطين (نطاقات)",
    activeErpUsers: "مستخدمي النظام المفعلين",
    pendingWhatsAppApprovals: "طلبات بانتظار الواتساب",
    wageProtectionSystem: "حماية الأجور (WPS)",
    wpsMudadCompliant: "ملفات SIF متوافقة 100% مع مُدد و SAMA",
    tabEmployees: "👥 دليل الموظفين وصلاحيات ERP",
    tabSalaryGosi: "💵 حاسبة الرواتب والتأمينات (GOSI)",
    tabWhatsApp: "موافقات الواتساب",
    tabPayrollWps: "🏦 مسير الرواتب وحماية الأجور (WPS)",
    empNumber: "الرقم الوظيفي",
    employeeName: "اسم الموظف",
    nationalIdOrIqama: "الهوية / الإقامة",
    jobTitleAndDept: "المنصب والقسم",
    bankAndIban: "الآيبان والبنك",
    erpAccessCol: "صلاحية النظام (ERP)",
    approvalStatusCol: "حالة الاعتماد",
    statusApprovedWhatsApp: "معتمد بالواتساب",
    statusPendingWhatsApp: "بانتظار موافقة الواتساب",
    statusRejected: "مرفوض",
    saudiCitizen: "سعودي",
    expatriate: "مقيم",
    noAccess: "بدون صلاحية",
    modulesCount: "موديولات",
    generateMonthlyPayroll: "توليد مسير الشهر",
    submitWhatsAppApproval: "إرسال لاعتماد الواتساب",
    downloadSifMudad: "تنزيل ملف SIF لمُدد",
    basicSalary: "الراتب الأساسي",
    housingAllowance: "بدل السكن",
    transportAllowance: "بدل النقل",
    otherAllowances: "بدلات أخرى",
    grossSalary: "إجمالي الراتب الاسمي",
    gosiSubjectWage: "الأجر الخاضع للتأمينات (GOSI)",
    employeeGosiDeduction: "استقطاع التأمينات من الموظف",
    netSalary: "صافي الراتب المحول للبنك",
    employerGosiCost: "اشتراك المنشأة في التأمينات",
    eosbMonthlyLiability: "مخصص مكافأة نهاية الخدمة (مادة 84)",
    registeredStakeholders: "أصحاب المصلحة المعتمدين",
    addApprover: "+ إضافة معتمد",
    liveWhatsAppAuditTrail: "سجل طلبات اعتماد الواتساب المباشرة",
    simulateApproval: "محاكاة الموافقة",
    simulateRejection: "رفض",
    sendWhatsAppPing: "إرسال تنبيه واتساب مباشر",
    editPermissions: "تعديل صلاحيات النظام",
    salaryContractAndGosi: "عقد الراتب والتأمينات",
    saveAndSendWhatsApp: "حفظ وتوجيه للاعتماد عبر الواتساب",
    selectEmployee: "اختر الموظف",
    standard25Pct: "المعيار (25%)",
    standard10Pct: "المعيار (10%)",
    effectiveDate: "تاريخ بدء السريان",
    saveEmployee: "حفظ الموظف وتوجيه الاعتمادات",
    enableErpAccess: "تفعيل حساب دخول الموظف لنظام الـ ERP",
    assignedRole: "الدور الوظيفي",
    dataScope: "نطاق رؤية البيانات",
    scopeOwnRecords: "سجلاته الشخصية فقط",
    scopeDeptRecords: "سجلات قسمه فقط",
    scopeAllOrgRecords: "كامل سجلات المنشأة",
    allowedModules: "الموديولات المصرح له بالدخول إليها",
    wpsSifReady: "معمارية ملف SAMA / Mudad SIF جاهزة للإيداع البنكي",
    totalNetPayable: "إجمالي الصافي المحول للبنوك",
    eligibleEmployees: "عدد الموظفين",
    qiwaContractCol: "عقد منصة قوى",
    qiwaContractTitle: "ربط وتوثيق عقد منصة قوى (Qiwa MHRSD)",
    qiwaContractNumber: "رقم عقد قوى (مثال: QW-10829471)",
    qiwaContractStatus: "حالة توثيق العقد في قوى",
    qiwaAuthenticated: "موثق وساري",
    qiwaPendingSignature: "بانتظار قبول الموظف (أبشر)",
    qiwaDraft: "مسودة عقد",
    qiwaUnlinked: "غير مربوط بقوى",
    qiwaComplianceNotice: "تنبيه مطابقة مُدد وقوى (WPS)",
    qiwaPreFlightWarningTitle: "تنبيه التحقق المسبق لمطابقة قوى ومدد",
    qiwaPreFlightWarningDesc: "يوجد موظفون بدون عقود موثقة في منصة قوى. نظام حماية الأجور (مُدد) يطابق مسيرات الرواتب تلقائياً مع عقود قوى الموثقة.",
    qiwaFullyCompliant: "مطابق 100% مع منصة قوى ونظام حماية الأجور",
    qiwaFullyCompliantDesc: "جميع الموظفين لديهم عقود موثقة وسارية في منصة قوى، ومسيرات الرواتب متوافقة تماماً مع متطلبات مدد وبنك الرواتب.",
    tabLeavesVacations: "🏖️ الإجازات والغياب",
    leavesSubDesc: "إدارة وتتبع الإجازات السنوية والمرضية وفقاً لنظام العمل السعودي (المواد 109-117) مع الاحتساب التلقائي لخصومات مسير الرواتب ورموز مدد (WPS).",
    recordLeaveRequest: "+ تسجيل إجازة موظف",
    leaveType: "نوع الإجازة",
    annualLeave: "إجازة سنوية (مدفوعة بالكامل - مادة 109)",
    sickLeave: "إجازة مرضية (شرائح مادة 117)",
    unpaidLeave: "إجازة بدون راتب (مادة 116)",
    marriageLeave: "إجازة زواج (5 أيام مدفوعة)",
    paternityLeave: "إجازة أبوة (3 أيام مدفوعة)",
    bereavementLeave: "إجازة وفاة (5 أيام مدفوعة)",
    maternityLeave: "إجازة وضع (10 أسابيع مدفوعة)",
    hajjLeave: "إجازة حج (10-15 يوماً)",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    daysCount: "عدد الأيام",
    medicalReportRef: "رقم التقرير الطبي (منصة صحتي)",
    mudadCodeCol: "رمز مدد (WPS)",
    sickLeaveTier1Desc: "الأيام 1-30: مدفوعة بالكامل (100%)",
    sickLeaveTier2Desc: "الأيام 31-90: ثلاثة أرباع الأجر (75%)",
    sickLeaveTier3Desc: "الأيام 91-120: بدون أجر (0%)",
  },

  en: {
    // Brand
    brandTitle: 'Trading ERP System',
    brandSub: 'All-in-one Cloud Sales, Inventory & Invoicing Platform',

    // Navigation
    navDashboard: 'Dashboard',
    navCustomers: 'Customers',
    navLeads: 'Leads & Opportunities',
    navInventory: 'Inventory & Stock',
    navSuppliers: 'Suppliers',
    navQuotations: 'Quotations',
    navDeliveryNotes: 'Delivery Notes',
    navInvoices: 'Invoices & Billing',
    navQuickPos: 'Quick POS Cashier',
    navVendorsHub: 'Vendors & Stores Hub',
    navAccounting: 'Accounting & Ledger',
    navGovernance: 'Corporate Governance',
    navProcurement: 'Procurement',
    navProfitSharing: 'Profit Sharing',
    navHr: 'HR & Workforce',
    descHr: 'Employee permissions, Saudi labor contracts, GOSI & WhatsApp sign-offs',
    navProcessFlow: 'Process Flow AI',
    navSettings: 'System Settings',
    navGlobalAdmin: 'Global Admin',

    // Header & User Menu
    userProfile: 'Profile',
    userSettings: 'Settings',
    userLogout: 'Logout',
    loggedOutTitle: 'Logged Out',
    loggedOutDesc: 'You have been successfully logged out',
    languageSelector: 'Language',
    selectLanguage: 'Select System Language',
    activeVendor: 'Active Store',
    switchVendor: 'Switch Store',
    quickActionPos: 'Open POS',

    // Common Buttons & Actions
    search: 'Search...',
    filter: 'Filter',
    exportCsv: 'Export CSV',
    addNew: '+ Add New',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    total: 'Total',
    loading: 'Loading...',
    back: 'Back',
    confirm: 'Confirm',
    refresh: 'Refresh',
    print: 'Print',
    all: 'All',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'Main Dashboard',
    dashWelcome: 'Welcome to your complete Trading ERP system',
    totalCustomers: 'Total Customers',
    activeLeads: 'Active Leads',
    inventoryItems: 'Inventory Items',
    quotations: 'Quotations',
    monthlyRevenue: 'Monthly Revenue',
    growthRate: 'Growth Rate',
    totalProfit: 'Total Profit',
    pendingProfit: 'Pending Profit',
    saudiSponsor: 'Saudi Sponsor',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    createNewCustomer: 'Create Customer',
    addNewLead: 'Add New Lead',
    generateQuotation: 'Generate Quotation',
    updateInventory: 'Update Inventory',
    activeProcesses: 'Active Processes',
    completedToday: 'Completed Today',
    pendingActions: 'Pending Actions',
    aiRecommendations: 'AI Recommendations',

    // Vendors Hub
    vendorsTitle: 'Vendors & Store Hub',
    vendorsSub: 'Central administration hub to monitor all registered stores, products, and direct POS access',
    registerNewVendor: 'Register New Vendor',
    exportDirectoryCsv: 'Export Directory (CSV)',
    totalRegisteredVendors: 'Total Registered Vendors',
    activeStores: 'Active Stores',
    catalogedItems: 'Cataloged Products',
    businessSectors: 'Business Sectors',
    searchVendorsPlaceholder: 'Search by store name, owner, mobile, CR number, VAT number...',
    allSectors: 'All Sectors',
    allStatuses: 'All Statuses',
    activeStatus: 'Active & Operating',
    suspendedStatus: 'Suspended / Inactive',
    colStoreOwner: 'Store & Owner',
    colSectorTax: 'Sector & Tax Info',
    colContact: 'Contact Details',
    colCatalog: 'Catalog',
    colStatus: 'Status',
    colActions: 'Actions',
    openStorePos: 'Open Store POS',
    manageProducts: 'Manage Products',
    editStoreDetails: 'Edit Store Details',
    resetPassword: 'Reset Password',
    suspendStore: 'Suspend Store',
    activateStore: 'Activate Store',
    deleteStore: 'Delete Store',

    // Customers
    customersTitle: 'Customer Management',
    customersSub: 'Manage your customer profiles, contact info, and credit terms',
    addCustomerBtn: '+ Add Customer',
    searchCustomersPlaceholder: 'Search customers by name, company, or email...',
    colCustomerName: 'Customer / Company Name',
    colType: 'Type',
    colContactPerson: 'Contact Person',
    colEmail: 'Email',
    colPhone: 'Phone',
    colCreditLimit: 'Credit Limit',
    colReliability: 'Reliability',
    businessType: 'Business',
    individualType: 'Individual',

    // Inventory
    invTitle: 'Inventory & Stock Management',
    invSub: 'Track product quantities, costs, sales prices, and suppliers',
    addItemBtn: '+ Add New Item',
    bulkImportBtn: 'Bulk CSV Import',
    bulkExportBtn: 'Export Inventory',
    searchInvPlaceholder: 'Search by item name, SKU, barcode, or category...',
    colItemName: 'Item Name',
    colSku: 'Barcode / SKU',
    colCategory: 'Category',
    colStock: 'Stock Qty',
    colCostPrice: 'Cost Price',
    colSellingPrice: 'Selling Price',
    colMargin: 'Margin',
    colSupplier: 'Supplier',
    inStock: 'In Stock',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',

    // POS Categories
    catAll: 'All',
    catBeverages: 'Beverages',
    catFood: 'Food',
    catServices: 'Services',
    catGeneral: 'General',

    // Payment & Store
    cardPayment: 'Card / Mada',
    cashPayment: 'Cash',
    vatShort: 'VAT',
    crShort: 'CR',
    cashier: 'Cashier',
    registeredStoreDetails: 'Store Account Details',
    ownerCashier: 'Owner / Cashier',
    currencyLabel: 'Currency',
    itemsUnit: 'Items',
    storeNameLabel: 'Store Name',
    ownerNameLabel: 'Owner',
    mobileLabel: 'Mobile',
    categoryLabel: 'Category',
    quickAddTooltip: 'Quick add product for instant sale',
    bulkCsvTooltip: 'Bulk product import via CSV or Excel',
    storeProductsTooltip: 'Manage store products catalog',

    // Vendor Catalog
    vendorCatalogTitle: 'Store Products & Catalog',
    vendorCatalogSub: 'Manage products and prices to reflect instantly in POS',
    goToPosBtn: 'Open POS Cashier',
    bulkCsvBtn: 'Bulk Import (CSV)',
    addNewProductBtn: 'Add Product',
    searchProductPlaceholder: 'Search by name or SKU / barcode...',
    allCategoriesOpt: 'All Categories',
    displayedCount: 'Displayed Products',
    colVatPrice: 'Price (VAT Incl.)',
    noProductsInCatalog: 'No products found',
    addFirstProductPrompt: 'Add your first product to get started',
    editProductModalTitle: 'Edit Product Details',
    saveChangesBtn: 'Save Changes',
    cancelBtn: 'Cancel',

    // Vendor Management Filters & Options
    activeOnly: 'Active Only',
    suspendedOnly: 'Suspended',
    whatsappTooltip: 'Quick WhatsApp Chat',
    launchPosBtn: 'Launch POS',
    manageCatalogBtn: 'Manage Catalog',
    editStoreBtn: 'Edit Store Details',
    changePasswordBtn: 'Change Password',
    suspendStoreBtn: 'Suspend Store',
    activateStoreBtn: 'Activate Store',
    deleteStoreBtn: 'Delete Store Permanently',
    noVendorsFound: 'No stores found matching your search',
    noVendorsSub: 'You can add a new store or clear search filters',

    // Vendor Registration & Modal
    registerVendorTitle: 'Register New Vendor',
    registerVendorSub: 'Add a new vendor with instant account activation & ZATCA POS',
    storeArabicName: 'Store Name (Arabic)',
    ownerManagerName: 'Owner / Manager Name',
    mobileUsername: 'Mobile Number (Username)',
    emailOptional: 'Email (Optional)',
    initialPassword: 'Initial Password',
    businessSector: 'Business Sector / Category',
    vatNumber15: 'VAT Number (15 digits)',
    crNumber: 'Commercial Registration (CR)',
    saveRegisterVendor: 'Save & Register Vendor',
    editVendorTitle: 'Edit Vendor Details',
    editVendorSub: 'Update contact details, VAT and CR numbers',
    resetPasswordTitle: 'Set New Password',
    newPasswordLabel: 'New Password',
    updatePasswordBtn: 'Update Password',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'Quick Add Product',
    quickAddSub: 'Product will appear immediately in cashier POS for instant sale',
    productArabicName: 'Product Name (Arabic)',
    productEnglishName: 'Product Name (English)',
    priceVatIncl: 'Price (VAT Included)',
    barcodeOptional: 'Barcode / SKU (Optional)',
    productCategory: 'Category',
    customCategoryOpt: '➕ Custom Category...',
    saveToPosBtn: 'Save & Add to POS',
    bulkImportTitle: 'Bulk Products Import (CSV)',
    downloadSampleCsvBtn: 'Download Sample CSV',
    pasteCsvOrExcel: 'Paste CSV rows or copy from Excel to import dozens of products at once',
    csvDataLabel: 'Product Data (CSV format)',
    uploadingProducts: 'Uploading products...',
    supportedColumnsTip: 'Supported Columns (10 complete or 5 quick columns):',
    supportedColumnsList: '1. Arabic Name • 2. English Name • 3. Selling Price • 4. Cost Price • 5. Category • 6. Barcode • 7. Stock • 8. Unit • 9. VAT Rate % • 10. Min Alert',
    bulkImportTip: '💡 Supports direct copy-paste from Excel or downloading the ready sample CSV file.',
    importAllProductsNow: 'Import All Products Now',
    deleteProductConfirm: 'Are you sure you want to delete this product?',
    itemUnitPiece: 'Pcs',

    // Language setting label
    langSettingTitle: 'System & App Language (Universal)',
    langSettingDesc: 'Select your preferred language across all ERP screens, POS, and dashboards',

    // Enterprise Operations Hub & Tiles
    hubSearchPlaceholder: 'Search modules, workflows, or shortcuts (e.g., Quotations, Invoices, PO)...',
    hubSubtitle: 'Unified Enterprise Operations & Intelligent Management Hub',
    hubQuickStats: 'Key Performance Indicators & Executive Overview',
    hubCatAll: 'All Modules',
    catSales: 'Sales & CRM',
    catSupply: 'Supply Chain & Procurement',
    catRetail: 'Point of Sale & Retail',
    catFinance: 'Finance & Governance',
    catSystem: 'Operations & System',
    openModule: 'Open Module',
    backToDashboard: 'Back to Dashboard',
    viewAllRecords: 'View All Records',
    badgeLive: 'Live',
    systemStatus: 'System Operational',
    quickShortcuts: 'Quick Shortcuts',
    filterByCategory: 'Filter by Domain',

    // Module Descriptions
    descCustomers: 'Manage corporate accounts, credit limits, contacts & directory',
    descLeads: 'Track sales pipeline, opportunities, conversion & stages',
    descQuotations: 'Generate formal quotations, itemization & track revisions',
    descDeliveryNotes: 'Issue delivery notes, track dispatch & shipment handovers',
    descInvoices: 'Issue ZATCA e-invoices, track receivables & payment statuses',
    descProcurement: 'Manage Purchase Requisitions (PR), Orders (PO) & Receiving',
    descSuppliers: 'Supplier directory, commercial registrations & vendor ratings',
    descInventory: 'Stock catalog, SKU management, low stock alerts & warehouse',
    descQuickPos: 'Fast cashier checkout, barcode scanning & instant ZATCA receipt',
    descVendorsHub: 'Manage multi-vendor outlets, commission models & store profiles',
    descAccounting: 'Double-entry bookkeeping, chart of accounts, vouchers & ledger',
    descGovernance: 'Board meetings, resolutions, shareholder register & compliance',
    descProfitSharing: 'Net profit distribution, partner equity & sponsor allocation',
    descProcessFlow: 'Intelligent process tracking, workflow automation & alerts',
    descSettings: 'Company info, ZATCA Phase-2, tax rates & user preferences',
    descGlobalAdmin: 'Multi-tenant administration, organization setup & global access',

    // HR & Workforce
    hrTitle: "HR & Workforce Management",
    hrSub: "Restricted ERP access control, Saudi Labor contracts & GOSI contributions, WPS payroll, and WhatsApp stakeholder approvals",
    hrKsaComplianceBadge: "KSA Labor Law & WPS Compliant",
    manageWhatsAppApprovers: "Manage WhatsApp Approvers",
    addNewEmployee: "+ Add New Employee",
    totalWorkforce: "Total Workforce",
    saudizationRate: "Saudization (Nitaqat)",
    activeErpUsers: "Active ERP Users",
    pendingWhatsAppApprovals: "Pending WhatsApp Approvals",
    wageProtectionSystem: "Wage Protection (WPS)",
    wpsMudadCompliant: "100% SAMA / Mudad SIF Ready",
    tabEmployees: "👥 Employee Directory & ERP Access",
    tabSalaryGosi: "💵 Salary & GOSI Calculator",
    tabWhatsApp: "WhatsApp Approvals",
    tabPayrollWps: "🏦 Monthly Payroll & WPS (Mudad)",
    empNumber: "Emp #",
    employeeName: "Employee Name",
    nationalIdOrIqama: "National ID / Iqama",
    jobTitleAndDept: "Job Title & Dept",
    bankAndIban: "Bank & IBAN",
    erpAccessCol: "ERP Access",
    approvalStatusCol: "Approval Status",
    statusApprovedWhatsApp: "Approved via WhatsApp",
    statusPendingWhatsApp: "Pending WhatsApp Sign-off",
    statusRejected: "Rejected",
    saudiCitizen: "Saudi",
    expatriate: "Expat",
    noAccess: "No Access",
    modulesCount: "modules",
    generateMonthlyPayroll: "Generate Monthly Payroll",
    submitWhatsAppApproval: "Submit for WhatsApp Sign-off",
    downloadSifMudad: "Download SIF for Mudad",
    basicSalary: "Basic Salary",
    housingAllowance: "Housing Allowance",
    transportAllowance: "Transportation Allowance",
    otherAllowances: "Other Allowances",
    grossSalary: "Gross Nominal Salary",
    gosiSubjectWage: "GOSI Subject Wage",
    employeeGosiDeduction: "Employee GOSI Deduction",
    netSalary: "Net Bank Payable Salary",
    employerGosiCost: "Employer GOSI Contribution",
    eosbMonthlyLiability: "End of Service Accrual (Art. 84)",
    registeredStakeholders: "Registered Stakeholder Approvers",
    addApprover: "+ Add Approver",
    liveWhatsAppAuditTrail: "Live WhatsApp Approval Audit Trail",
    simulateApproval: "Simulate Approval",
    simulateRejection: "Reject",
    sendWhatsAppPing: "Send WhatsApp Ping",
    editPermissions: "Configure ERP Permissions",
    salaryContractAndGosi: "Salary Contract & GOSI",
    saveAndSendWhatsApp: "Save & Request WhatsApp Sign-off",
    selectEmployee: "Select Employee",
    standard25Pct: "Standard (25%)",
    standard10Pct: "Standard (10%)",
    effectiveDate: "Effective Date",
    saveEmployee: "Save Employee & Route Approvals",
    enableErpAccess: "Enable ERP System Access for Employee",
    assignedRole: "Assigned Role",
    dataScope: "Data Visibility Scope",
    scopeOwnRecords: "Own Records Only",
    scopeDeptRecords: "Department Records Only",
    scopeAllOrgRecords: "All Organization Records",
    allowedModules: "Authorized System Modules",
    wpsSifReady: "SAMA / Mudad SIF File Structure Ready for Bank Deposit",
    totalNetPayable: "Total Net Bank Payout",
    eligibleEmployees: "Eligible Employees",
    qiwaContractCol: "Qiwa Contract",
    qiwaContractTitle: "Qiwa Platform Contract Authentication",
    qiwaContractNumber: "Qiwa Contract Number (e.g. QW-10829471)",
    qiwaContractStatus: "Qiwa Contract Status",
    qiwaAuthenticated: "Authenticated & Active",
    qiwaPendingSignature: "Pending Employee Acceptance (Absher)",
    qiwaDraft: "Draft Contract",
    qiwaUnlinked: "Unlinked / Not on Qiwa",
    qiwaComplianceNotice: "Qiwa & Mudad WPS Compliance Notice",
    qiwaPreFlightWarningTitle: "Pre-Flight Qiwa & Mudad Compliance Check",
    qiwaPreFlightWarningDesc: "There are employees without authenticated Qiwa contracts. Mudad automatically verifies payroll files against Qiwa authenticated contracts.",
    qiwaFullyCompliant: "100% Qiwa & Mudad WPS Compliant",
    qiwaFullyCompliantDesc: "All employees have active, authenticated Qiwa contracts and are fully eligible for WPS Mudad submission without compliance violations.",
    tabLeavesVacations: "🏖️ Leaves & Vacations",
    leavesSubDesc: "Track annual, sick, and unpaid leaves compliant with Saudi Labor Law (Articles 109-117) with automated payroll deduction adjustments and Mudad (WPS) codes.",
    recordLeaveRequest: "+ Record Employee Leave",
    leaveType: "Leave Type",
    annualLeave: "Annual Leave (100% Paid - Art. 109)",
    sickLeave: "Sick Leave (Art. 117 Tiers)",
    unpaidLeave: "Unpaid Leave (Art. 116)",
    marriageLeave: "Marriage Leave (5 Days Paid)",
    paternityLeave: "Paternity Leave (3 Days Paid)",
    bereavementLeave: "Bereavement Leave (5 Days Paid)",
    maternityLeave: "Maternity Leave (10 Weeks Paid)",
    hajjLeave: "Hajj Pilgrimage Leave (10-15 Days)",
    startDate: "Start Date",
    endDate: "End Date",
    daysCount: "Duration (Days)",
    medicalReportRef: "Medical Report # (Sehhaty صحتي)",
    mudadCodeCol: "Mudad WPS Code",
    sickLeaveTier1Desc: "Days 1-30: 100% Full Pay",
    sickLeaveTier2Desc: "Days 31-90: 75% Three-Quarters Pay",
    sickLeaveTier3Desc: "Days 91-120: 0% Unpaid",
  },

  hi: {
    // Brand
    brandTitle: 'ट्रेडिंग ईआरपी सिस्टम',
    brandSub: 'क्लाउड बिक्री, इन्वेंट्री और चालान प्रणाली',

    // Navigation
    navDashboard: 'डैशबोर्ड',
    navCustomers: 'ग्राहक',
    navLeads: 'लीड्स और अवसर',
    navInventory: 'इन्वेंट्री और स्टॉक',
    navSuppliers: 'आपूर्तिकर्ता',
    navQuotations: 'कोटेशन (दरें)',
    navDeliveryNotes: 'डिलीवरी नोट्स',
    navInvoices: 'चालान (इनवॉइस)',
    navQuickPos: 'त्वरित पीओएस कैशियर',
    navVendorsHub: 'विक्रेता और स्टोर हब',
    navAccounting: 'लेखांकन (अकाउंटिंग)',
    navGovernance: 'कॉर्पोरेट शासन',
    navProcurement: 'खरीद और आपूर्ति',
    navProfitSharing: 'लाभ साझाकरण',
    navProcessFlow: 'प्रक्रिया प्रवाह',
    navSettings: 'सिस्टम सेटिंग्स',
    navGlobalAdmin: 'ग्लोबल एडमिन',

    // Header & User Menu
    userProfile: 'प्रोफ़ाइल',
    userSettings: 'सेटिंग्स',
    userLogout: 'लॉग आउट',
    loggedOutTitle: 'लॉग आउट हो गया',
    loggedOutDesc: 'आप सफलतापूर्वक लॉग आउट हो गए हैं',
    languageSelector: 'भाषा',
    selectLanguage: 'भाषा चुनें',
    activeVendor: 'सक्रिय स्टोर',
    switchVendor: 'स्टोर बदलें',
    quickActionPos: 'पीओएस खोलें',

    // Common Buttons & Actions
    search: 'खोजें...',
    filter: 'फ़िल्टर',
    exportCsv: 'सीएसवी निर्यात',
    addNew: '+ नया जोड़ें',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    view: 'देखें',
    actions: 'कार्रवाई',
    status: 'स्थिति',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    total: 'कुल',
    loading: 'लोड हो रहा है...',
    back: 'वापस',
    confirm: 'पुष्टि करें',
    refresh: 'ताज़ा करें',
    print: 'प्रिंट करें',
    all: 'सभी',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'मुख्य डैशबोर्ड',
    dashWelcome: 'ट्रेडिंग ईआरपी सिस्टम में आपका स्वागत है',
    totalCustomers: 'कुल ग्राहक',
    activeLeads: 'सक्रिय लीड्स',
    inventoryItems: 'इन्वेंट्री उत्पाद',
    quotations: 'कोटेशन',
    monthlyRevenue: 'मासिक आय',
    growthRate: 'विकास दर',
    totalProfit: 'कुल लाभ',
    pendingProfit: 'लंबित लाभ',
    saudiSponsor: 'सऊदी प्रायोजक',
    recentActivity: 'हाल की गतिविधि',
    quickActions: 'त्वरित कार्य',
    createNewCustomer: 'नया ग्राहक बनाएं',
    addNewLead: 'नई लीड जोड़ें',
    generateQuotation: 'कोटेशन बनाएं',
    updateInventory: 'इन्वेंट्री अपडेट करें',
    activeProcesses: 'सक्रिय प्रक्रियाएं',
    completedToday: 'आज पूर्ण',
    pendingActions: 'लंबित कार्य',
    aiRecommendations: 'एआई सुझाव',

    // Vendors Hub
    vendorsTitle: 'विक्रेता और स्टोर हब',
    vendorsSub: 'सभी पंजीकृत स्टोर, उत्पादों और पीओएस के लिए केंद्रीय प्रशासन केंद्र',
    registerNewVendor: 'नया स्टोर पंजीकृत करें',
    exportDirectoryCsv: 'निर्देशिका निर्यात करें (CSV)',
    totalRegisteredVendors: 'कुल पंजीकृत स्टोर',
    activeStores: 'सक्रिय स्टोर',
    catalogedItems: 'कैटलॉग उत्पाद',
    businessSectors: 'व्यावसायिक क्षेत्र',
    searchVendorsPlaceholder: 'स्टोर का नाम, मालिक, मोबाइल, सीआर या वैट नंबर से खोजें...',
    allSectors: 'सभी क्षेत्र',
    allStatuses: 'सभी स्थितियाँ',
    activeStatus: 'सक्रिय',
    suspendedStatus: 'निलंबित',
    colStoreOwner: 'स्टोर और मालिक',
    colSectorTax: 'क्षेत्र और कर विवरण',
    colContact: 'संपर्क सूत्र',
    colCatalog: 'कैटलॉग',
    colStatus: 'स्थिति',
    colActions: 'कार्रवाई',
    openStorePos: 'पीओएस खोलें',
    manageProducts: 'उत्पाद प्रबंधित करें',
    editStoreDetails: 'विवरण संपादित करें',
    resetPassword: 'पासवर्ड रीसेट करें',
    suspendStore: 'निलंबित करें',
    activateStore: 'सक्रिय करें',
    deleteStore: 'हटाएं',

    // Customers
    customersTitle: 'ग्राहक प्रबंधन',
    customersSub: 'ग्राहक प्रोफाइल और संपर्क जानकारी प्रबंधित करें',
    addCustomerBtn: '+ नया ग्राहक',
    searchCustomersPlaceholder: 'नाम, कंपनी या ईमेल से खोजें...',
    colCustomerName: 'ग्राहक / कंपनी का नाम',
    colType: 'प्रकार',
    colContactPerson: 'संपर्क व्यक्ति',
    colEmail: 'ईमेल',
    colPhone: 'फ़ोन',
    colCreditLimit: 'क्रेडिट सीमा',
    colReliability: 'विश्वसनीयता',
    businessType: 'व्यापार',
    individualType: 'व्यक्तिगत',

    // Inventory
    invTitle: 'इन्वेंट्री प्रबंधन',
    invSub: 'उत्पाद मात्रा, लागत, मूल्य और आपूर्तिकर्ता ट्रैक करें',
    addItemBtn: '+ नया आइटम',
    bulkImportBtn: 'थोक सीएसवी आयात',
    bulkExportBtn: 'इन्वेंट्री निर्यात',
    searchInvPlaceholder: 'नाम, एसकेयू, बारकोड या श्रेणी से खोजें...',
    colItemName: 'आइटम का नाम',
    colSku: 'बारकोड / SKU',
    colCategory: 'श्रेणी',
    colStock: 'स्टॉक मात्रा',
    colCostPrice: 'लागत मूल्य',
    colSellingPrice: 'बिक्री मूल्य',
    colMargin: 'मार्जिन',
    colSupplier: 'आपूर्तिकर्ता',
    inStock: 'स्टॉक में',
    lowStock: 'कम स्टॉक',
    outOfStock: 'स्टॉक ख़त्म',

    // POS Categories
    catAll: 'सभी',
    catBeverages: 'पेय पदार्थ',
    catFood: 'भोजन',
    catServices: 'सेवाएं',
    catGeneral: 'सामान्य',

    // Payment & Store
    cardPayment: 'कार्ड / मादा (Card/Mada)',
    cashPayment: 'नकद (Cash)',
    vatShort: 'वैट (VAT)',
    crShort: 'सीआर (CR)',
    cashier: 'कैशियर',
    registeredStoreDetails: 'पंजीकृत स्टोर विवरण',
    ownerCashier: 'मालिक / कैशियर',
    currencyLabel: 'मुद्रा',
    itemsUnit: 'वस्तुएं',
    storeNameLabel: 'स्टोर का नाम',
    ownerNameLabel: 'मालिक',
    mobileLabel: 'मोबाइल',
    categoryLabel: 'श्रेणी',
    quickAddTooltip: 'त्वरित बिक्री के लिए उत्पाद जोड़ें',
    bulkCsvTooltip: 'सीएसवी या एक्सेल द्वारा थोक आयात',
    storeProductsTooltip: 'स्टोर उत्पाद सूची प्रबंधित करें',

    // Vendor Catalog
    vendorCatalogTitle: 'स्टोर उत्पाद और कैटलॉग',
    vendorCatalogSub: 'पीओएस कैशियर में तुरंत दिखाने के लिए उत्पादों और कीमतों को प्रबंधित करें',
    goToPosBtn: 'पीओएस कैशियर खोलें',
    bulkCsvBtn: 'थोक आयात (CSV)',
    addNewProductBtn: 'नया उत्पाद',
    searchProductPlaceholder: 'नाम या बारकोड / SKU से खोजें...',
    allCategoriesOpt: 'सभी श्रेणियां',
    displayedCount: 'प्रदर्शित उत्पाद',
    colVatPrice: 'कीमत (वैट सहित)',
    noProductsInCatalog: 'कोई उत्पाद नहीं मिला',
    addFirstProductPrompt: 'शुरू करने के लिए अपना पहला उत्पाद जोड़ें',
    editProductModalTitle: 'उत्पाद विवरण संपादित करें',
    saveChangesBtn: 'परिवर्तन सहेजें',
    cancelBtn: 'रद्द करें',

    // Vendor Management Filters & Options
    activeOnly: 'केवल सक्रिय',
    suspendedOnly: 'निलंबित',
    whatsappTooltip: 'त्वरित व्हाट्सएप चैट',
    launchPosBtn: 'पीओएस शुरू करें',
    manageCatalogBtn: 'कैटलॉग प्रबंधित करें',
    editStoreBtn: 'स्टोर विवरण संपादित करें',
    changePasswordBtn: 'पासवर्ड बदलें',
    suspendStoreBtn: 'स्टोर निलंबित करें',
    activateStoreBtn: 'स्टोर सक्रिय करें',
    deleteStoreBtn: 'स्टोर स्थायी रूप से हटाएं',
    noVendorsFound: 'आपकी खोज से मेल खाने वाला कोई स्टोर नहीं मिला',
    noVendorsSub: 'आप नया स्टोर जोड़ सकते हैं या फ़िल्टर हटा सकते हैं',

    // Vendor Registration & Modal
    registerVendorTitle: 'नया स्टोर पंजीकृत करें',
    registerVendorSub: 'तत्काल खाता और ZATCA POS के साथ नया विक्रेता जोड़ें',
    storeArabicName: 'स्टोर का नाम (अरबी)',
    ownerManagerName: 'मालिक / प्रबंधक का नाम',
    mobileUsername: 'मोबाइल नंबर (उपयोगकर्ता नाम)',
    emailOptional: 'ईमेल (वैकल्पिक)',
    initialPassword: 'प्रारंभिक पासवर्ड',
    businessSector: 'व्यावसायिक क्षेत्र / गतिविधि',
    vatNumber15: 'वैट संख्या (15 अंक)',
    crNumber: 'वाणिज्यिक पंजीकरण संख्या (CR)',
    saveRegisterVendor: 'स्टोर सहेजें और पंजीकृत करें',
    editVendorTitle: 'विक्रेता विवरण संपादित करें',
    editVendorSub: 'संपर्क, वैट और सीआर विवरण अपडेट करें',
    resetPasswordTitle: 'नया पासवर्ड सेट करें',
    newPasswordLabel: 'नया पासवर्ड',
    updatePasswordBtn: 'पासवर्ड अपडेट करें',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'त्वरित उत्पाद जोड़ें',
    quickAddSub: 'उत्पाद तत्काल बिक्री के लिए पीओएस कैशियर में तुरंत दिखाई देगा',
    productArabicName: 'उत्पाद का नाम (अरबी)',
    productEnglishName: 'उत्पाद का नाम (अंग्रेजी)',
    priceVatIncl: 'कीमत (वैट सहित)',
    barcodeOptional: 'बारकोड / SKU (वैकल्पिक)',
    productCategory: 'श्रेणी',
    customCategoryOpt: '➕ नई कस्टम श्रेणी...',
    saveToPosBtn: 'सहेजें और पीओएस में जोड़ें',
    bulkImportTitle: 'थोक उत्पाद आयात (CSV)',
    downloadSampleCsvBtn: 'नमूना CSV डाउनलोड करें',
    pasteCsvOrExcel: 'एक साथ दर्जनों उत्पाद जोड़ने के लिए CSV पेस्ट करें या Excel से कॉपी करें',
    csvDataLabel: 'उत्पाद डेटा (CSV प्रारूप)',
    uploadingProducts: 'उत्पाद अपलोड हो रहे हैं...',
    supportedColumnsTip: 'समर्थित कॉलम (10 पूर्ण या 5 त्वरित कॉलम):',
    supportedColumnsList: '1. अरबी नाम • 2. अंग्रेजी नाम • 3. बिक्री मूल्य • 4. लागत मूल्य • 5. श्रेणी • 6. बारकोड • 7. मात्रा • 8. इकाई • 9. वैट % • 10. न्यूनतम सीमा',
    bulkImportTip: '💡 एक्सेल से सीधे कॉपी-पेस्ट करें या तैयार नमूना सीएसवी फ़ाइल डाउनलोड करें।',
    importAllProductsNow: 'सभी उत्पाद अभी आयात करें',
    deleteProductConfirm: 'क्या आप वाकई इस उत्पाद को हटाना चाहते हैं?',
    itemUnitPiece: 'टुकड़ा (Pcs)',

    // Language setting label
    langSettingTitle: 'सिस्टम भाषा (सार्वभौमिक)',
    langSettingDesc: 'सभी स्क्रीन और पीओएस के लिए अपनी पसंदीदा भाषा चुनें',

    // HR & Workforce
    hrTitle: "मानव संसाधन और कार्यबल प्रबंधन (HR)",
    hrSub: "प्रतिबंधित ईआरपी पहुंच, सऊदी श्रम अनुबंध और जीओएसआई, डब्ल्यूपीएस पेरोल और व्हाट्सएप अनुमोदन प्रबंधित करें",
    hrKsaComplianceBadge: "सऊदी श्रम कानून और WPS अनुपालन",
    manageWhatsAppApprovers: "व्हाट्सएप अनुमोदक प्रबंधित करें",
    addNewEmployee: "+ नया कर्मचारी जोड़ें",
    totalWorkforce: "कुल कार्यबल",
    saudizationRate: "सऊदीकरण (Nitaqat)",
    activeErpUsers: "सक्रिय ईआरपी उपयोगकर्ता",
    pendingWhatsAppApprovals: "लंबित व्हाट्सएप अनुमोदन",
    wageProtectionSystem: "वेतन संरक्षण प्रणाली (WPS)",
    wpsMudadCompliant: "100% SAMA / मुदद SIF तैयार",
    tabEmployees: "👥 कर्मचारी निर्देशिका और ईआरपी पहुंच",
    tabSalaryGosi: "💵 वेतन और जीओएसआई कैलकुलेटर",
    tabWhatsApp: "व्हाट्सएप अनुमोदन",
    tabPayrollWps: "🏦 मासिक पेरोल और डब्ल्यूपीएस (मुदद)",
    empNumber: "कर्मचारी #",
    employeeName: "कर्मचारी का नाम",
    nationalIdOrIqama: "राष्ट्रीय पहचान / इकामा",
    jobTitleAndDept: "पद और विभाग",
    bankAndIban: "बैंक और IBAN",
    erpAccessCol: "ईआरपी पहुंच",
    approvalStatusCol: "अनुमोदन स्थिति",
    statusApprovedWhatsApp: "व्हाट्सएप द्वारा अनुमोदित",
    statusPendingWhatsApp: "लंबित व्हाट्सएप हस्ताक्षर",
    statusRejected: "अस्वीकृत",
    saudiCitizen: "सऊदी",
    expatriate: "प्रवासी",
    noAccess: "कोई पहुंच नहीं",
    modulesCount: "मॉड्यूल",
    generateMonthlyPayroll: "मासिक पेरोल उत्पन्न करें",
    submitWhatsAppApproval: "व्हाट्सएप अनुमोदन के लिए भेजें",
    downloadSifMudad: "मुदद के लिए SIF डाउनलोड करें",
    basicSalary: "मूल वेतन",
    housingAllowance: "आवास भत्ता",
    transportAllowance: "परिवहन भत्ता",
    otherAllowances: "अन्य भत्ते",
    grossSalary: "सकल वेतन",
    gosiSubjectWage: "जीओएसआई अंशदायी वेतन",
    employeeGosiDeduction: "कर्मचारी जीओएसआई कटौती",
    netSalary: "शुद्ध देय बैंक वेतन",
    employerGosiCost: "नियोक्ता जीओएसआई अंशदान",
    eosbMonthlyLiability: "सेवा समाप्ति उपदान संचय (अनुच्छेद 84)",
    registeredStakeholders: "पंजीकृत हितधारक अनुमोदक",
    addApprover: "+ अनुमोदक जोड़ें",
    liveWhatsAppAuditTrail: "लाइव व्हाट्सएप अनुमोदन ऑडिट ट्रेल",
    simulateApproval: "अनुमोदन अनुकरण करें",
    simulateRejection: "अस्वीकार करें",
    sendWhatsAppPing: "व्हाट्सएप संदेश भेजें",
    editPermissions: "ईआरपी अनुमतियां कॉन्फ़िगर करें",
    salaryContractAndGosi: "वेतन अनुबंध और जीओएसआई",
    saveAndSendWhatsApp: "सहेजें और व्हाट्सएप हस्ताक्षर का अनुरोध करें",
    selectEmployee: "कर्मचारी चुनें",
    standard25Pct: "मानक (25%)",
    standard10Pct: "मानक (10%)",
    effectiveDate: "प्रभावी तिथि",
    saveEmployee: "कर्मचारी सहेजें और अनुमोदन अग्रेषित करें",
    enableErpAccess: "कर्मचारी के लिए ईआरपी एक्सेस सक्षम करें",
    assignedRole: "निर्धारित भूमिका",
    dataScope: "डेटा दृश्यता दायरा",
    scopeOwnRecords: "केवल अपने रिकॉर्ड",
    scopeDeptRecords: "केवल विभाग रिकॉर्ड",
    scopeAllOrgRecords: "संगठन के सभी रिकॉर्ड",
    allowedModules: "अधिकृत सिस्टम मॉड्यूल",
    wpsSifReady: "बैंक जमा के लिए SAMA / मुदद SIF फ़ाइल तैयार",
    totalNetPayable: "कुल शुद्ध बैंक भुगतान",
    eligibleEmployees: "पात्र कर्मचारी",
    qiwaContractCol: "क़िवा अनुबंध",
    qiwaContractTitle: "क़िवा प्लेटफ़ॉर्म अनुबंध प्रमाणीकरण",
    qiwaContractNumber: "क़िवा अनुबंध संख्या (उदा. QW-10829471)",
    qiwaContractStatus: "क़िवा अनुबंध की स्थिति",
    qiwaAuthenticated: "प्रमाणित और सक्रिय",
    qiwaPendingSignature: "कर्मचारी स्वीकृति लंबित (Absher)",
    qiwaDraft: "ड्राफ्ट अनुबंध",
    qiwaUnlinked: "क़िवा से लिंक नहीं",
    qiwaComplianceNotice: "क़िवा और मुदाद WPS अनुपालन सूचना",
    qiwaPreFlightWarningTitle: "क़िवा और मुदाद अनुपालन पूर्व-जांच",
    qiwaPreFlightWarningDesc: "ऐसे कर्मचारी हैं जिनके पास प्रमाणित क़िवा अनुबंध नहीं हैं। मुदाद स्वचालित रूप से क़िवा प्रमाणित अनुबंधों के खिलाफ पेरोल फ़ाइलों की पुष्टि करता है।",
    qiwaFullyCompliant: "100% क़िवा और मुदाद WPS अनुरूप",
    qiwaFullyCompliantDesc: "सभी कर्मचारियों के पास सक्रिय, प्रमाणित क़िवा अनुबंध हैं और वे बिना किसी समस्या के मुदाद पेरोल के लिए योग्य हैं।",
  },

  ur: {
    // Brand
    brandTitle: 'ٹریڈنگ ای آر پی سسٹم',
    brandSub: 'کلاؤڈ سیلز، انوینٹری اور بلنگ کا مکمل پلیٹ فارم',

    // Navigation
    navDashboard: 'ڈیش بورڈ',
    navCustomers: 'گاہک / کسٹمرز',
    navLeads: 'لیڈز اور مواقع',
    navInventory: 'انوینٹری اور اسٹاک',
    navSuppliers: 'سپلائرز',
    navQuotations: 'کوٹیشنز (نرخ نامہ)',
    navDeliveryNotes: 'ڈیلیوری نوٹس',
    navInvoices: 'انوائسز اور بلنگ',
    navQuickPos: 'فوری پی او ایس کیشیئر',
    navVendorsHub: 'وینڈرز اور اسٹورز ہب',
    navAccounting: 'اکاؤنٹنگ اور مالیات',
    navGovernance: 'کارپوریٹ گورننس',
    navProcurement: 'خریداری اور سپلائی',
    navProfitSharing: 'منافع کی تقسیم',
    navProcessFlow: 'سمارٹ پروسیس فلو',
    navSettings: 'سسٹم ترتیبات',
    navGlobalAdmin: 'گلوبل ایڈمن',

    // Header & User Menu
    userProfile: 'پروفائل',
    userSettings: 'ترتیبات',
    userLogout: 'لاگ آؤٹ',
    loggedOutTitle: 'لاگ آؤٹ مکمل ہوا',
    loggedOutDesc: 'آپ کامیابی کے ساتھ لاگ آؤٹ ہو چکے ہیں',
    languageSelector: 'زبان',
    selectLanguage: 'سسٹم کی زبان منتخب کریں',
    activeVendor: 'فعال اسٹور',
    switchVendor: 'اسٹور تبدیل کریں',
    quickActionPos: 'کیشیئر کھولیں',

    // Common Buttons & Actions
    search: 'تلاش کریں...',
    filter: 'فلٹر',
    exportCsv: 'ایکسپورٹ CSV',
    addNew: '+ نیا شامل کریں',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
    delete: 'حذف کریں',
    edit: 'ترمیم کریں',
    view: 'دیکھیں',
    actions: 'اقدامات',
    status: 'حیثیت',
    active: 'فعال',
    inactive: 'غیر فعال / معطل',
    total: 'کل رقم',
    loading: 'لوڈ ہو رہا ہے...',
    back: 'پیچھے',
    confirm: 'تصدیق کریں',
    refresh: 'تازہ کریں',
    print: 'پرنٹ کریں',
    all: 'سب',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'مرکزی ڈیش بورڈ',
    dashWelcome: 'ٹریڈنگ ای آر پی سسٹم میں خوش آمدید',
    totalCustomers: 'کل گاہک',
    activeLeads: 'فعال مواقع',
    inventoryItems: 'انوینٹری آئٹمز',
    quotations: 'کوٹیشنز',
    monthlyRevenue: 'ماہانہ آمدنی',
    growthRate: 'شرح نمو',
    totalProfit: 'کل منافع',
    pendingProfit: 'زیر التوا منافع',
    saudiSponsor: 'سعودی کفیل',
    recentActivity: 'حالیہ سرگرمی',
    quickActions: 'فوری اقدامات',
    createNewCustomer: 'نیا گاہک بنائیں',
    addNewLead: 'نیا موقع شامل کریں',
    generateQuotation: 'کوٹیشن بنائیں',
    updateInventory: 'انوینٹری اپ ڈیٹ کریں',
    activeProcesses: 'فعال پراسیسز',
    completedToday: 'آج مکمل شدہ',
    pendingActions: 'زیر التوا اقدامات',
    aiRecommendations: 'اے آئی تجاویز',

    // Vendors Hub
    vendorsTitle: 'وینڈرز اور اسٹورز ہب',
    vendorsSub: 'تمام رجسٹرڈ اسٹورز، مصنوعات اور پی او ایس تک براہ راست رسائی کا مرکزی کنٹرول',
    registerNewVendor: 'نیا اسٹور رجسٹر کریں',
    exportDirectoryCsv: 'ڈائریکٹری ایکسپورٹ (CSV)',
    totalRegisteredVendors: 'کل رجسٹرڈ اسٹورز',
    activeStores: 'فعال اسٹورز',
    catalogedItems: 'کیٹلاگ آئٹمز',
    businessSectors: 'تجارتی شعبہ جات',
    searchVendorsPlaceholder: 'اسٹور کا نام، مالک، موبائل، سی آر، یا ٹیکس نمبر سے تلاش کریں...',
    allSectors: 'تمام شعبے',
    allStatuses: 'تمام حالتیں',
    activeStatus: 'فعال',
    suspendedStatus: 'معطل',
    colStoreOwner: 'اسٹور اور مالک',
    colSectorTax: 'شعبہ اور ٹیکس',
    colContact: 'رابطہ کی تفصیلات',
    colCatalog: 'کیٹلاگ',
    colStatus: 'حیثیت',
    colActions: 'اقدامات',
    openStorePos: 'پی او ایس کھولیں',
    manageProducts: 'مصنوعات کی تفصیلات',
    editStoreDetails: 'اسٹور میں ترمیم',
    resetPassword: 'پاس ورڈ ری سیٹ',
    suspendStore: 'معطل کریں',
    activateStore: 'فعال کریں',
    deleteStore: 'حذف کریں',

    // Customers
    customersTitle: 'کسٹمر مینجمنٹ',
    customersSub: 'گاہکوں کی پروفائلز اور تفصیلات کا انتظام کریں',
    addCustomerBtn: '+ نیا کسٹمر',
    searchCustomersPlaceholder: 'نام، کمپنی یا ای میل سے تلاش کریں...',
    colCustomerName: 'کسٹمر / کمپنی کا نام',
    colType: 'قسم',
    colContactPerson: 'رابطہ کار',
    colEmail: 'ای میل',
    colPhone: 'فون',
    colCreditLimit: 'کریڈٹ کی حد',
    colReliability: 'معتبریت',
    businessType: 'کاروبار',
    individualType: 'انفرادی',

    // Inventory
    invTitle: 'انوینٹری مینجمنٹ',
    invSub: 'اسٹاک کی مقدار، لاگت، فروخت کی قیمت اور سپلائرز کی نگرانی کریں',
    addItemBtn: '+ نیا آئٹم',
    bulkImportBtn: 'بلک درآمد (CSV)',
    bulkExportBtn: 'ایکسپورٹ انوینٹری',
    searchInvPlaceholder: 'آئٹم کا نام، بارکوڈ، ایس کے یو یا زمرہ تلاش کریں...',
    colItemName: 'آئٹم کا نام',
    colSku: 'بارکوڈ / SKU',
    colCategory: 'زمرہ',
    colStock: 'دستیاب اسٹاک',
    colCostPrice: 'لاگت کی قیمت',
    colSellingPrice: 'فروخت کی قیمت',
    colMargin: 'منافع کا مارجن',
    colSupplier: 'سپلائر',
    inStock: 'دستیاب',
    lowStock: 'کم اسٹاک',
    outOfStock: 'ختم ہو چکا ہے',

    // POS Categories
    catAll: 'سب',
    catBeverages: 'مشروبات',
    catFood: 'کھانا',
    catServices: 'خدمات',
    catGeneral: 'عام',

    // Payment & Store
    cardPayment: 'مدى / کارڈ',
    cashPayment: 'نقد (کیش)',
    vatShort: 'ٹیکس (VAT)',
    crShort: 'سی آر',
    cashier: 'کیشیئر',
    registeredStoreDetails: 'رجسٹرڈ اسٹور کی تفصیلات',
    ownerCashier: 'مالک / کیشیئر',
    currencyLabel: 'کرنسی',
    itemsUnit: 'آئٹمز',
    storeNameLabel: 'اسٹور کا نام',
    ownerNameLabel: 'مالک کا نام',
    mobileLabel: 'موبائل نمبر',
    categoryLabel: 'زمرہ',
    quickAddTooltip: 'فوری فروخت کیلئے آئٹم شامل کریں',
    bulkCsvTooltip: 'CSV یا ایکسل کے ذریعے بلک امپورٹ',
    storeProductsTooltip: 'اسٹور کی مصنوعات کا کیٹلاگ منظم کریں',

    // Vendor Catalog
    vendorCatalogTitle: 'اسٹور مصنوعات اور کیٹلاگ',
    vendorCatalogSub: 'کیشیئر اسکرین میں فوری ظاہر کرنے کیلئے مصنوعات اور قیمتیں شامل اور تبدیل کریں',
    goToPosBtn: 'پی او ایس کیشیئر کھولیں',
    bulkCsvBtn: 'بلک امپورٹ (CSV)',
    addNewProductBtn: 'نیا آئٹم شامل کریں',
    searchProductPlaceholder: 'نام یا بارکوڈ / SKU سے تلاش کریں...',
    allCategoriesOpt: 'تمام زمرہ جات',
    displayedCount: 'دکھائے گئے آئٹمز',
    colVatPrice: 'قیمت بمع ٹیکس',
    noProductsInCatalog: 'کوئی آئٹم نہیں ملا',
    addFirstProductPrompt: 'شروع کرنے کیلئے اپنا پہلا آئٹم شامل کریں',
    editProductModalTitle: 'آئٹم کی تفصیلات میں ترمیم',
    saveChangesBtn: 'تبدیلیاں محفوظ کریں',
    cancelBtn: 'منسوخ کریں',

    // Vendor Management Filters & Options
    activeOnly: 'صرف فعال',
    suspendedOnly: 'معطل شدہ',
    whatsappTooltip: 'فوری واٹس ایپ بات چیت',
    launchPosBtn: 'پی او ایس شروع کریں',
    manageCatalogBtn: 'کیٹلاگ منظم کریں',
    editStoreBtn: 'اسٹور تفصیلات میں ترمیم',
    changePasswordBtn: 'پاس ورڈ تبدیل کریں',
    suspendStoreBtn: 'اسٹور معطل کریں',
    activateStoreBtn: 'اسٹور فعال کریں',
    deleteStoreBtn: 'اسٹور مستقل طور پر حذف کریں',
    noVendorsFound: 'تلاش کے مطابق کوئی اسٹور نہیں ملا',
    noVendorsSub: 'آپ نیا اسٹور شامل کر سکتے ہیں یا فلٹرز صاف کر سکتے ہیں',

    // Vendor Registration & Modal
    registerVendorTitle: 'نیا اسٹور رجسٹر کریں',
    registerVendorSub: 'فوری اکاؤنٹ اور ZATCA POS کے ساتھ نیا اسٹور شامل کریں',
    storeArabicName: 'اسٹور کا نام (عربی)',
    ownerManagerName: 'مالک / منیجر کا نام',
    mobileUsername: 'موبائل نمبر (یوزر نیم)',
    emailOptional: 'ای میل (اختیاری)',
    initialPassword: 'ابتدائی پاس ورڈ',
    businessSector: 'کاروباری شعبہ / زمرہ',
    vatNumber15: 'ٹیکس نمبر (15 ہندسے)',
    crNumber: 'کمرشل رجسٹریشن نمبر (CR)',
    saveRegisterVendor: 'اسٹور محفوظ اور رجسٹر کریں',
    editVendorTitle: 'اسٹور تفصیلات میں ترمیم',
    editVendorSub: 'رابطہ، ٹیکس اور رجسٹریشن نمبر اپ ڈیٹ کریں',
    resetPasswordTitle: 'نیا پاس ورڈ سیٹ کریں',
    newPasswordLabel: 'نیا پاس ورڈ',
    updatePasswordBtn: 'پاس ورڈ اپ ڈیٹ کریں',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'فوری آئٹم شامل کریں',
    quickAddSub: 'فوری فروخت کیلئے آئٹم فوری طور پر کیشیئر اسکرین میں ظاہر ہوگا',
    productArabicName: 'آئٹم کا نام (عربی)',
    productEnglishName: 'آئٹم کا نام (انگریزی)',
    priceVatIncl: 'قیمت بمع ٹیکس',
    barcodeOptional: 'بارکوڈ / SKU (اختیاری)',
    productCategory: 'زمرہ',
    customCategoryOpt: '➕ نیا مخصوص زمرہ...',
    saveToPosBtn: 'محفوظ کریں اور کیشیئر میں شامل کریں',
    bulkImportTitle: 'بلک مصنوعات امپورٹ (CSV)',
    downloadSampleCsvBtn: 'نمونہ CSV ڈاؤن لوڈ کریں',
    pasteCsvOrExcel: 'ایک ساتھ درجنوں آئٹمز امپورٹ کرنے کیلئے CSV چسپاں کریں یا ایکسل سے کاپی کریں',
    csvDataLabel: 'مصنوعات کا ڈیٹا (CSV فارمیٹ)',
    uploadingProducts: 'مصنوعات اپ لوڈ ہو رہی ہیں...',
    supportedColumnsTip: 'معاون کالمز (10 مکمل یا 5 فوری کالمز):',
    supportedColumnsList: '1. عربی نام • 2. انگریزی نام • 3. فروخت کی قیمت • 4. لاگت کی قیمت • 5. زمرہ • 6. بارکوڈ • 7. مقدار • 8. یونٹ • 9. ٹیکس شرح % • 10. کم از کم الرٹ',
    bulkImportTip: '💡 ایکسل سے براہ راست کاپی پیسٹ کی سہولت یا تیار نمونہ CSV فائل ڈاؤن لوڈ کریں۔',
    importAllProductsNow: 'تمام آئٹمز ابھی امپورٹ کریں',
    deleteProductConfirm: 'کیا آپ واقعی اس آئٹم کو حذف کرنا چاہتے ہیں؟',
    itemUnitPiece: 'عدد (Pcs)',

    // Language setting label
    langSettingTitle: 'سسٹم کی زبان (عالمگیر)',
    langSettingDesc: 'تمام اسکرینز اور پی او ایس کیلئے اپنی پسندیدہ زبان منتخب کریں',

    // HR & Workforce
    hrTitle: "ہیومن ریسورس اور تنخواہوں کا انتظام (HR)",
    hrSub: "ملازمین کی محدود ERP رسائی، سعودی لیبر کنٹریکٹس، GOSI، WPS پے رول اور واٹس ایپ منظوریوں کا انتظام",
    hrKsaComplianceBadge: "سعودی لیبر قانون اور WPS کے مطابق",
    manageWhatsAppApprovers: "واٹس ایپ منظور کنندگان کا انتظام",
    addNewEmployee: "+ نیا ملازم شامل کریں",
    totalWorkforce: "کل ورک فورس",
    saudizationRate: "سعودائزیشن (نطاقات)",
    activeErpUsers: "فعال ERP صارفین",
    pendingWhatsAppApprovals: "زیر التواء واٹس ایپ منظوریاں",
    wageProtectionSystem: "اجرت کے تحفظ کا نظام (WPS)",
    wpsMudadCompliant: "100% SAMA / مدد SIF تیار",
    tabEmployees: "👥 ملازمین کی ڈائرکٹری اور ERP رسائی",
    tabSalaryGosi: "💵 تنخواہ اور GOSI کیلکولیٹر",
    tabWhatsApp: "واٹس ایپ منظوریاں",
    tabPayrollWps: "🏦 ماہانہ پے رول اور WPS (مدد)",
    empNumber: "ملازم #",
    employeeName: "ملازم کا نام",
    nationalIdOrIqama: "قومی شناختی کارڈ / اقامہ",
    jobTitleAndDept: "عہدہ اور شعبہ",
    bankAndIban: "بینک اور IBAN",
    erpAccessCol: "ERP رسائی",
    approvalStatusCol: "منظوری کی حیثیت",
    statusApprovedWhatsApp: "واٹس ایپ سے منظور شدہ",
    statusPendingWhatsApp: "واٹس ایپ منظوری کا انتظار",
    statusRejected: "مسترد",
    saudiCitizen: "سعودی",
    expatriate: "مقیم",
    noAccess: "کوئی رسائی نہیں",
    modulesCount: "ماڈیولز",
    generateMonthlyPayroll: "ماہانہ پے رول تیار کریں",
    submitWhatsAppApproval: "واٹس ایپ منظوری کے لیے بھیجیں",
    downloadSifMudad: "مدد کے لیے SIF ڈاؤن لوڈ کریں",
    basicSalary: "بنیادی تنخواہ",
    housingAllowance: "رہائش الاؤنس",
    transportAllowance: "ٹرانسپورٹ الاؤنس",
    otherAllowances: "دیگر الاؤنسز",
    grossSalary: "مجموعی تنخواہ",
    gosiSubjectWage: "GOSI قابل اطلاق اجرت",
    employeeGosiDeduction: "ملازم کی GOSI کٹوتی",
    netSalary: "بینک میں قابل ادا خالص تنخواہ",
    employerGosiCost: "کمپنی کا GOSI حصہ",
    eosbMonthlyLiability: "گریجویٹی الاؤنس (دفعہ 84)",
    registeredStakeholders: "رجسٹرڈ اسٹیک ہولڈر منظور کنندگان",
    addApprover: "+ منظور کنندہ شامل کریں",
    liveWhatsAppAuditTrail: "لائیو واٹس ایپ منظوری آڈٹ ٹریل",
    simulateApproval: "منظوری کی نقالی کریں",
    simulateRejection: "مسترد کریں",
    sendWhatsAppPing: "براہ راست واٹس ایپ الرٹ بھیجیں",
    editPermissions: "ERP اجازتیں ترتیب دیں",
    salaryContractAndGosi: "تنخواہ کا معاہدہ اور GOSI",
    saveAndSendWhatsApp: "محفوظ کریں اور واٹس ایپ منظوری بھیجیں",
    selectEmployee: "ملازم منتخب کریں",
    standard25Pct: "معیاری (25%)",
    standard10Pct: "معیاری (10%)",
    effectiveDate: "نافذ العمل تاریخ",
    saveEmployee: "ملازم محفوظ کریں اور منظوری بھیجیں",
    enableErpAccess: "ملازم کے لیے ERP تک رسائی فعال کریں",
    assignedRole: "مقرر کردہ کردار",
    dataScope: "ڈیٹا دیکھنے کا دائرہ کار",
    scopeOwnRecords: "صرف اپنے ریکارڈز",
    scopeDeptRecords: "صرف اپنے شعبے کے ریکارڈز",
    scopeAllOrgRecords: "پوری کمپنی کے ریکارڈز",
    allowedModules: "مجاز ماڈیولز",
    wpsSifReady: "بینک ڈپازٹ کے لیے SAMA / مدد SIF فائل تیار ہے",
    totalNetPayable: "کل خالص بینک ادائیگی",
    eligibleEmployees: "اہل ملازمین",
    qiwaContractCol: "قویٰ معاہدہ",
    qiwaContractTitle: "منصة قوى معاہدے کی توثیق",
    qiwaContractNumber: "قویٰ معاہدہ نمبر (مثال: QW-10829471)",
    qiwaContractStatus: "قویٰ معاہدے کی حیثیت",
    qiwaAuthenticated: "تصدیق شدہ اور فعال",
    qiwaPendingSignature: "ابشر پر ملازم کی منظوری کا منتظر",
    qiwaDraft: "معاہدے کا مسودہ",
    qiwaUnlinked: "قویٰ سے غیر منسلک",
    qiwaComplianceNotice: "قویٰ اور مدد ڈبلیو پی ایس تعمیل کا نوٹس",
    qiwaPreFlightWarningTitle: "قویٰ اور مدد تعمیل کی پیشگی جانچ",
    qiwaPreFlightWarningDesc: "کچھ ملازمین کے پاس منصة قوى پر تصدیق شدہ معاہدے نہیں ہیں۔ مدد کا نظام خود کار طریقے سے قوى کے تصدیق شدہ معاہدوں سے تنخواہوں کی مطابقت چیک کرتا ہے۔",
    qiwaFullyCompliant: "منصة قوى اور مدد ڈبلیو پی ایس کے ساتھ 100٪ مطابقت",
    qiwaFullyCompliantDesc: "تمام ملازمین کے پاس فعال اور تصدیق شدہ قوى معاہدے ہیں اور وہ بغیر کسی جرمانے کے مدد میں جمع کروانے کے اہل ہیں۔",
  },

  bn: {
    // Brand
    brandTitle: 'ট্রেডিং ইআরপি সিস্টেম',
    brandSub: 'বিক্রয়, ইনভেন্টরি এবং ইনভয়েসিং প্ল্যাটফর্ম',

    // Navigation
    navDashboard: 'ড্যাশবোর্ড',
    navCustomers: 'গ্রাহকবৃন্দ',
    navLeads: 'সম্ভাব্য গ্রাহক (Leads)',
    navInventory: 'ইনভেন্টরি ও স্টক',
    navSuppliers: 'সরবরাহকারী',
    navQuotations: 'কোটেশন',
    navDeliveryNotes: 'ডেলিভারি নোট',
    navInvoices: 'ইনভয়েস ও বিলিং',
    navQuickPos: 'কুইক পিওএস ক্যাশিয়ার',
    navVendorsHub: 'ভেন্ডর ও স্টোর হাব',
    navAccounting: 'হিসাবরক্ষণ ও অর্থায়ন',
    navGovernance: 'কর্পোরেট গভর্নেন্স',
    navProcurement: 'ক্রয় ও সংগ্রহ',
    navProfitSharing: 'লাভ ভাগাভাগি',
    navProcessFlow: 'প্রসেস ফ্লো এআই',
    navSettings: 'সিস্টেম সেটিংস',
    navGlobalAdmin: 'গ্লোবাল অ্যাডমিন',

    // Header & User Menu
    userProfile: 'প্রোফাইল',
    userSettings: 'সেটিংস',
    userLogout: 'লগআউট',
    loggedOutTitle: 'লগআউট সম্পন্ন',
    loggedOutDesc: 'আপনি সফলভাবে লগআউট হয়েছেন',
    languageSelector: 'ভাষা',
    selectLanguage: 'সিস্টেম ভাষা নির্বাচন করুন',
    activeVendor: 'সক্রিয় স্টোর',
    switchVendor: 'স্টোর পরিবর্তন',
    quickActionPos: 'পিওএস খুলুন',

    // Common Buttons & Actions
    search: 'অনুসন্ধান...',
    filter: 'ফিল্টার',
    exportCsv: 'CSV রপ্তানি',
    addNew: '+ নতুন যোগ করুন',
    save: 'সংরক্ষণ করুন',
    cancel: 'বাতিল',
    delete: 'মুছে ফেলুন',
    edit: 'সম্পাদনা',
    view: 'দেখুন',
    actions: 'পদক্ষেপ',
    status: 'অবস্থা',
    active: 'সক্রিয়',
    inactive: 'নিষ্ক্রিয়',
    total: 'মোট',
    loading: 'লোড হচ্ছে...',
    back: 'ফিরে যান',
    confirm: 'নিশ্চিত করুন',
    refresh: 'রিফ্রেশ',
    print: 'প্রিন্ট',
    all: 'সব',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'মূল ড্যাশবোর্ড',
    dashWelcome: 'ট্রেডিং ইআরপি সিস্টেমে স্বাগতম',
    totalCustomers: 'মোট গ্রাহক',
    activeLeads: 'সক্রিয় সুযোগ',
    inventoryItems: 'ইনভেন্টরি পণ্য',
    quotations: 'কোটেশন',
    monthlyRevenue: 'মাসিক রাজস্ব',
    growthRate: 'বৃদ্ধির হার',
    totalProfit: 'মোট লাভ',
    pendingProfit: 'বকেয়া লাভ',
    saudiSponsor: 'সৌদি স্পনসর',
    recentActivity: 'সাম্প্রতিক কার্যকলাপ',
    quickActions: 'দ্রুত পদক্ষেপ',
    createNewCustomer: 'নতুন গ্রাহক যোগ',
    addNewLead: 'নতুন লিড যোগ',
    generateQuotation: 'কোটেশন তৈরি',
    updateInventory: 'ইনভেন্টরি আপডেট',
    activeProcesses: 'সক্রিয় প্রক্রিয়া',
    completedToday: 'আজ সম্পন্ন',
    pendingActions: 'বকেয়া কাজ',
    aiRecommendations: 'এআই সুপারিশ',

    // Vendors Hub
    vendorsTitle: 'ভেন্ডর ও স্টোর হাব',
    vendorsSub: 'সমস্ত নিবন্ধিত দোকান, পণ্য এবং পিওএস পর্যবেক্ষণের কেন্দ্রীয় হাব',
    registerNewVendor: 'নতুন দোকান নিবন্ধন',
    exportDirectoryCsv: 'ডিরেক্টরি রপ্তানি (CSV)',
    totalRegisteredVendors: 'মোট নিবন্ধিত দোকান',
    activeStores: 'সক্রিয় দোকান',
    catalogedItems: 'ক্যাটালগ পণ্য',
    businessSectors: 'ব্যবসায়িক ক্ষেত্র',
    searchVendorsPlaceholder: 'দোকানের নাম, মালিক, মোবাইল বা কর নম্বর দিয়ে অনুসন্ধান...',
    allSectors: 'সব ক্ষেত্র',
    allStatuses: 'সব অবস্থা',
    activeStatus: 'সক্রিয়',
    suspendedStatus: 'স্থগিত',
    colStoreOwner: 'দোকান ও মালিক',
    colSectorTax: 'ক্ষেত্র ও ট্যাক্স',
    colContact: 'যোগাযোগ',
    colCatalog: 'ক্যাটালগ',
    colStatus: 'অবস্থা',
    colActions: 'পদক্ষেপ',
    openStorePos: 'পিওএস খুলুন',
    manageProducts: 'পণ্য পরিচালনা',
    editStoreDetails: 'বিবরণ সম্পাদনা',
    resetPassword: 'পাসওয়ার্ড রিসেট',
    suspendStore: 'স্থগিত করুন',
    activateStore: 'সক্রিয় করুন',
    deleteStore: 'মুছে ফেলুন',

    // Customers
    customersTitle: 'গ্রাহক ব্যবস্থাপনা',
    customersSub: 'গ্রাহকের প্রোফাইল ও তথ্যাদি পরিচালনা করুন',
    addCustomerBtn: '+ নতুন গ্রাহক',
    searchCustomersPlaceholder: 'নাম, কোম্পানি বা ইমেইল দিয়ে খুঁজুন...',
    colCustomerName: 'গ্রাহক / কোম্পানির নাম',
    colType: 'ধরন',
    colContactPerson: 'দায়িত্বপ্রাপ্ত ব্যক্তি',
    colEmail: 'ইমেইল',
    colPhone: 'ফোন',
    colCreditLimit: 'ক্রেডিট সীমা',
    colReliability: 'নির্ভরযোগ্যতা',
    businessType: 'ব্যবসা',
    individualType: 'ব্যক্তিগত',

    // Inventory
    invTitle: 'ইনভেন্টরি ও স্টক ব্যবস্থাপনা',
    invSub: 'পণ্যের পরিমাণ, খরচ, বিক্রয় মূল্য ও সরবরাহকারী পর্যবেক্ষণ করুন',
    addItemBtn: '+ নতুন পণ্য',
    bulkImportBtn: 'বাল্ক CSV আমদানি',
    bulkExportBtn: 'ইনভেন্টরি রপ্তানি',
    searchInvPlaceholder: 'নাম, এসকেইউ বা ক্যাটাগরি দিয়ে খুঁজুন...',
    colItemName: 'পণ্যের নাম',
    colSku: 'বারকোড / SKU',
    colCategory: 'ক্যাটাগরি',
    colStock: 'মজুদ পরিমাণ',
    colCostPrice: 'ক্রয় মূল্য',
    colSellingPrice: 'বিক্রয় মূল্য',
    colMargin: 'মার্জিন',
    colSupplier: 'সরবরাহকারী',
    inStock: 'মজুদ আছে',
    lowStock: 'কম মজুদ',
    outOfStock: 'মজুদ নেই',

    // POS Categories
    catAll: 'সব',
    catBeverages: 'পানীয়',
    catFood: 'খাবার',
    catServices: 'সেবা',
    catGeneral: 'সাধারণ',

    // Payment & Store
    cardPayment: 'কার্ড / মাদা (Card/Mada)',
    cashPayment: 'নগদ (Cash)',
    vatShort: 'ভ্যাট (VAT)',
    crShort: 'সিআর (CR)',
    cashier: 'ক্যাশিয়ার',
    registeredStoreDetails: 'নিবন্ধিত দোকানের বিবরণ',
    ownerCashier: 'মালিক / ক্যাশিয়ার',
    currencyLabel: 'মুদ্রা',
    itemsUnit: 'পণ্য',
    storeNameLabel: 'দোকানের নাম',
    ownerNameLabel: 'মালিকের নাম',
    mobileLabel: 'মোবাইল',
    categoryLabel: 'বিভাগ',
    quickAddTooltip: 'তাৎক্ষণিক বিক্রির জন্য পণ্য যোগ করুন',
    bulkCsvTooltip: 'CSV বা এক্সেলের মাধ্যমে বাল্ক আমদানি',
    storeProductsTooltip: 'দোকানের পণ্যের ক্যাটালগ পরিচালনা করুন',

    // Vendor Catalog
    vendorCatalogTitle: 'দোকানের পণ্য ও ক্যাটালগ',
    vendorCatalogSub: 'ক্যাশিয়ার স্ক্রিনে তাৎক্ষণিক দেখানোর জন্য পণ্য ও মূল্য পরিচালনা করুন',
    goToPosBtn: 'পিওএস ক্যাশিয়ার খুলুন',
    bulkCsvBtn: 'বাল্ক আমদানি (CSV)',
    addNewProductBtn: 'নতুন পণ্য',
    searchProductPlaceholder: 'নাম বা বারকোড / SKU দিয়ে অনুসন্ধান করুন...',
    allCategoriesOpt: 'সকল বিভাগ',
    displayedCount: 'প্রদর্শিত পণ্য',
    colVatPrice: 'মূল্য (ভ্যাট সহ)',
    noProductsInCatalog: 'কোনো পণ্য পাওয়া যায়নি',
    addFirstProductPrompt: 'শুরু করতে আপনার প্রথম পণ্য যোগ করুন',
    editProductModalTitle: 'পণ্যের বিবরণ সম্পাদনা',
    saveChangesBtn: 'পরিবর্তন সংরক্ষণ করুন',
    cancelBtn: 'বাতিল করুন',

    // Vendor Management Filters & Options
    activeOnly: 'শুধুমাত্র সক্রিয়',
    suspendedOnly: 'স্থগিত',
    whatsappTooltip: 'হোয়াটসঅ্যাপ চ্যাট',
    launchPosBtn: 'পিওএস শুরু করুন',
    manageCatalogBtn: 'ক্যাটালগ পরিচালনা',
    editStoreBtn: 'দোকানের তথ্য সম্পাদনা',
    changePasswordBtn: 'পাসওয়ার্ড পরিবর্তন',
    suspendStoreBtn: 'দোকান স্থগিত করুন',
    activateStoreBtn: 'দোকান সক্রিয় করুন',
    deleteStoreBtn: 'স্থায়ীভাবে দোকান মুছুন',
    noVendorsFound: 'অনুসন্ধানের সাথে কোনো দোকান মেলেনি',
    noVendorsSub: 'নতুন দোকান যোগ করুন বা ফিল্টার সাফ করুন',

    // Vendor Registration & Modal
    registerVendorTitle: 'নতুন দোকান নিবন্ধন',
    registerVendorSub: 'তাৎক্ষণিক অ্যাকাউন্ট ও ZATCA POS সহ নতুন বিক্রেতা যোগ করুন',
    storeArabicName: 'দোকানের নাম (আরবি)',
    ownerManagerName: 'মালিক / পরিচালকের নাম',
    mobileUsername: 'মোবাইল নম্বর (ইউজারনেম)',
    emailOptional: 'ইমেইল (ঐচ্ছিক)',
    initialPassword: 'প্রাথমিক পাসওয়ার্ড',
    businessSector: 'ব্যবসায়িক ক্ষেত্র / বিভাগ',
    vatNumber15: 'ভ্যাট নম্বর (১৫ সংখ্যা)',
    crNumber: 'বাণিজ্যিক নিবন্ধন নম্বর (CR)',
    saveRegisterVendor: 'দোকান সংরক্ষণ ও নিবন্ধন করুন',
    editVendorTitle: 'দোকানের বিবরণ সম্পাদনা',
    editVendorSub: 'যোগাযোগ, ভ্যাট এবং সিআর নম্বর আপডেট করুন',
    resetPasswordTitle: 'নতুন পাসওয়ার্ড সেট করুন',
    newPasswordLabel: 'নতুন পাসওয়ার্ড',
    updatePasswordBtn: 'পাসওয়ার্ড আপডেট করুন',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'দ্রুত পণ্য যোগ করুন',
    quickAddSub: 'পণ্যটি তাৎক্ষণিক বিক্রির জন্য পিওএস ক্যাশিয়ারে সরাসরি প্রদর্শিত হবে',
    productArabicName: 'পণ্যের নাম (আরবি)',
    productEnglishName: 'পণ্যের নাম (ইংরেজি)',
    priceVatIncl: 'মূল্য (ভ্যাট সহ)',
    barcodeOptional: 'বারকোড / SKU (ঐচ্ছিক)',
    productCategory: 'বিভাগ',
    customCategoryOpt: '➕ নতুন কাস্টম বিভাগ...',
    saveToPosBtn: 'সংরক্ষণ করুন এবং পিওএসে যোগ করুন',
    bulkImportTitle: 'বাল্ক পণ্য আমদানি (CSV)',
    downloadSampleCsvBtn: 'নমুনা CSV ডাউনলোড করুন',
    pasteCsvOrExcel: 'একসাথে ডজন ডজন পণ্য আমদানির জন্য CSV পেস্ট করুন বা Excel থেকে কপি করুন',
    csvDataLabel: 'পণ্যের তথ্য (CSV ফরম্যাট)',
    uploadingProducts: 'পণ্য আপলোড হচ্ছে...',
    supportedColumnsTip: 'সমর্থিত কলাম (১০টি পূর্ণ বা ৫টি দ্রুত কলাম):',
    supportedColumnsList: '১. আরবি নাম • ২. ইংরেজি নাম • ৩. বিক্রয় মূল্য • ৪. ক্রয় মূল্য • ৫. বিভাগ • ৬. বারকোড • ৭. স্টক • ৮. একক • ৯. ভ্যাট % • ১০. সতর্কতার সীমা',
    bulkImportTip: '💡 এক্সেল থেকে সরাসরি কপি-পেস্ট করুন অথবা প্রস্তুতকৃত নমুনা CSV ফাইল ডাউনলোড করুন।',
    importAllProductsNow: 'সমস্ত পণ্য এখনই আমদানি করুন',
    deleteProductConfirm: 'আপনি কি নিশ্চিত যে এই পণ্যটি মুছে ফেলতে চান?',
    itemUnitPiece: 'পিস (Pcs)',

    // Language setting label
    langSettingTitle: 'সিস্টেম ভাষা (সর্বজনীন)',
    langSettingDesc: 'সমস্ত স্ক্রিন ও পিওএসের জন্য আপনার পছন্দের ভাষা নির্বাচন করুন',

    // HR & Workforce
    hrTitle: "মানবসম্পদ ও কর্মীবাহিনী ব্যবস্থাপনা (HR)",
    hrSub: "সীমাবদ্ধ ERP অ্যাক্সেস, সৌদি শ্রম চুক্তি ও GOSI, WPS বেতন এবং হোয়াটসঅ্যাপ অনুমোদন পরিচালনা করুন",
    hrKsaComplianceBadge: "সৌদি শ্রম আইন ও WPS সম্মত",
    manageWhatsAppApprovers: "হোয়াটসঅ্যাপ অনুমোদনকারী পরিচালনা",
    addNewEmployee: "+ নতুন কর্মচারী যোগ করুন",
    totalWorkforce: "মোট কর্মীবাহিনী",
    saudizationRate: "সৌদিকরণ (Nitaqat)",
    activeErpUsers: "সক্রিয় ERP ব্যবহারকারী",
    pendingWhatsAppApprovals: "অপেক্ষমান হোয়াটসঅ্যাপ অনুমোদন",
    wageProtectionSystem: "মজুরি সুরক্ষা (WPS)",
    wpsMudadCompliant: "১০০% SAMA / মুদাদ SIF প্রস্তুত",
    tabEmployees: "👥 কর্মচারী ডিরেক্টরি ও ERP অ্যাক্সেস",
    tabSalaryGosi: "💵 বেতন ও GOSI ক্যালকুলেটর",
    tabWhatsApp: "হোয়াটসঅ্যাপ অনুমোদন",
    tabPayrollWps: "🏦 মাসিক বেতন ও WPS (মুদাদ)",
    empNumber: "কর্মচারী #",
    employeeName: "কর্মচারীর নাম",
    nationalIdOrIqama: "জাতীয় পরিচয়পত্র / ইকামাহ",
    jobTitleAndDept: "পদবী ও বিভাগ",
    bankAndIban: "ব্যাংক ও IBAN",
    erpAccessCol: "ERP অ্যাক্সেস",
    approvalStatusCol: "অনুমোদনের স্থিতি",
    statusApprovedWhatsApp: "হোয়াটসঅ্যাপে অনুমোদিত",
    statusPendingWhatsApp: "হোয়াটসঅ্যাপ স্বাক্ষরের অপেক্ষায়",
    statusRejected: "প্রত্যাখ্যাত",
    saudiCitizen: "সৌদি",
    expatriate: "প্রবাসী",
    noAccess: "কোন অ্যাক্সেস নেই",
    modulesCount: "মডিউল",
    generateMonthlyPayroll: "মাসিক বেতন তৈরি করুন",
    submitWhatsAppApproval: "হোয়াটসঅ্যাপ অনুমোদনের জন্য পাঠান",
    downloadSifMudad: "মুদাদের জন্য SIF ডাউনলোড করুন",
    basicSalary: "মূল বেতন",
    housingAllowance: "বাড়ি ভাড়া ভাতা",
    transportAllowance: "যাতায়াত ভাতা",
    otherAllowances: "অন্যান্য ভাতা",
    grossSalary: "মোট বেতন",
    gosiSubjectWage: "GOSI অন্তর্ভুক্ত মজুরি",
    employeeGosiDeduction: "কর্মচারীর GOSI কর্তন",
    netSalary: "ব্যাংকে প্রদেয় নেট বেতন",
    employerGosiCost: "নিয়োগদাতার GOSI অবদান",
    eosbMonthlyLiability: "চাকরি সমাপ্তি গ্র্যাচুইটি (ধারা ৮৪)",
    registeredStakeholders: "নিবন্ধিত অনুমোদনকারী",
    addApprover: "+ অনুমোদনকারী যোগ করুন",
    liveWhatsAppAuditTrail: "লাইভ হোয়াটসঅ্যাপ অনুমোদন অডিট লগ",
    simulateApproval: "অনুমোদন সিমুলেট করুন",
    simulateRejection: "প্রত্যাখ্যান করুন",
    sendWhatsAppPing: "হোয়াটসঅ্যাপ সতর্কতা পাঠান",
    editPermissions: "ERP অনুমতি কনফিগার করুন",
    salaryContractAndGosi: "বেতন চুক্তি ও GOSI",
    saveAndSendWhatsApp: "সংরক্ষণ ও হোয়াটসঅ্যাপে অনুমোদনের জন্য পাঠান",
    selectEmployee: "কর্মচারী নির্বাচন করুন",
    standard25Pct: "স্ট্যান্ডার্ড (২৫%)",
    standard10Pct: "স্ট্যান্ডার্ড (১০%)",
    effectiveDate: "কার্যকর তারিখ",
    saveEmployee: "সংরক্ষণ ও অনুমোদন রুট করুন",
    enableErpAccess: "কর্মচারীর জন্য ERP অ্যাক্সেস সক্রিয় করুন",
    assignedRole: "নির্ধারিত ভূমিকা",
    dataScope: "ডেটা দৃশ্যমানতার সুযোগ",
    scopeOwnRecords: "শুধুমাত্র নিজের রেকর্ড",
    scopeDeptRecords: "শুধুমাত্র বিভাগের রেকর্ড",
    scopeAllOrgRecords: "প্রতিষ্ঠানের সমস্ত রেকর্ড",
    allowedModules: "অনুমোদিত সিস্টেম মডিউল",
    wpsSifReady: "ব্যাংক জমার জন্য SAMA / মুদাদ SIF ফাইল প্রস্তুত",
    totalNetPayable: "মোট নেট ব্যাংক পরিশোধ",
    eligibleEmployees: "যোগ্য কর্মচারী",
    qiwaContractCol: "কিওয়া চুক্তি",
    qiwaContractTitle: "কিওয়া প্ল্যাটফর্ম চুক্তি যাচাইকরণ",
    qiwaContractNumber: "কিওয়া চুক্তি নম্বর (যেমন QW-10829471)",
    qiwaContractStatus: "কিওয়া চুক্তির অবস্থা",
    qiwaAuthenticated: "যাচাইকৃত ও সক্রিয়",
    qiwaPendingSignature: "অনুমোদনের অপেক্ষায় (Absher)",
    qiwaDraft: "খসড়া চুক্তি",
    qiwaUnlinked: "কিওয়ায় যুক্ত নয়",
    qiwaComplianceNotice: "কিওয়া এবং মুদাদ ডব্লিউপিএস কমপ্লায়েন্স নোটিশ",
    qiwaPreFlightWarningTitle: "কিওয়া এবং মুদাদ কমপ্লায়েন্স প্রি-ফ্লাইট চেক",
    qiwaPreFlightWarningDesc: "কিছু কর্মচারীর কিওয়া প্ল্যাটফর্মে যাচাইকৃত চুক্তি নেই। মুদাদ স্বয়ংক্রিয়ভাবে কিওয়ার যাচাইকৃত চুক্তির সাথে বেতন ফাইলের তুলনা করে।",
    qiwaFullyCompliant: "১০০% কিওয়া এবং মুদাদ ডব্লিউপিএস সম্মত",
    qiwaFullyCompliantDesc: "সকল কর্মচারীর সক্রিয়, যাচাইকৃত কিওয়া চুক্তি রয়েছে এবং জরিমানা ছাড়াই ডব্লিউপিএস মুদাদ জমা দেওয়ার উপযুক্ত।",
  },

  ne: {
    // Brand
    brandTitle: 'ट्रेडिङ ईआरपी प्रणाली',
    brandSub: 'बिक्री, मौज्दात र बिलिङको पूर्ण प्रणाली',

    // Navigation
    navDashboard: 'ड्यासबोर्ड',
    navCustomers: 'ग्राहकहरू',
    navLeads: 'सम्भावित अवसरहरू (Leads)',
    navInventory: 'इन्भेन्टरी र मौज्दात',
    navSuppliers: 'आपूर्तिकर्ताहरू',
    navQuotations: 'कोटेशनहरू',
    navDeliveryNotes: 'डिलिभरी नोटहरू',
    navInvoices: 'इनभ्वाइसहरू र बिलिङ',
    navQuickPos: 'द्रुत पीओएस क्यासियर',
    navVendorsHub: 'विक्रेता तथा स्टोर हब',
    navAccounting: 'लेखा तथा वित्त',
    navGovernance: 'कम्पनी सुशासन',
    navProcurement: 'खरीद तथा आपूर्ति',
    navProfitSharing: 'नाफा बाँडफाँड',
    navProcessFlow: 'स्मार्ट प्रक्रिया प्रवाह',
    navSettings: 'प्रणाली सेटिङहरू',
    navGlobalAdmin: 'ग्लोबल एडमिन',

    // Header & User Menu
    userProfile: 'प्रोफाइल',
    userSettings: 'सेटिङहरू',
    userLogout: 'लगआउट',
    loggedOutTitle: 'लगआउट भयो',
    loggedOutDesc: 'तपाईं सफलतापूर्वक लगआउट हुनुभएको छ',
    languageSelector: 'भाषा',
    selectLanguage: 'प्रणाली भाषा छान्नुहोस्',
    activeVendor: 'सक्रिय पसल',
    switchVendor: 'पसल परिवर्तन',
    quickActionPos: 'पीओएस खोल्नुहोस्',

    // Common Buttons & Actions
    search: 'खोज्नुहोस्...',
    filter: 'फिल्टर',
    exportCsv: 'CSV निर्यात',
    addNew: '+ नयाँ थप्नुहोस्',
    save: 'सुरक्षित गर्नुहोस्',
    cancel: 'रद्द गर्नुहोस्',
    delete: 'मेटाउनुहोस्',
    edit: 'सम्पादन गर्नुहोस्',
    view: 'हेर्नुहोस्',
    actions: 'कार्यहरू',
    status: 'स्थिति',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    total: 'जम्मा',
    loading: 'लोड हुँदैछ...',
    back: 'पछाडि',
    confirm: 'पुष्टि गर्नुहोस्',
    refresh: 'ताजा गर्नुहोस्',
    print: 'प्रिन्ट गर्नुहोस्',
    all: 'सबै',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'मुख्य ड्यासबोर्ड',
    dashWelcome: 'ट्रेडिङ ईआरपी प्रणालीमा स्वागत छ',
    totalCustomers: 'जम्मा ग्राहकहरू',
    activeLeads: 'सक्रिय अवसरहरू',
    inventoryItems: 'मौज्दात वस्तुहरू',
    quotations: 'कोटेशनहरू',
    monthlyRevenue: 'मासिक आम्दानी',
    growthRate: 'वृद्धि दर',
    totalProfit: 'कुल नाफा',
    pendingProfit: 'बाँकी नाफा',
    saudiSponsor: 'साउदी प्रायोजक',
    recentActivity: 'भर्खरका गतिविधि',
    quickActions: 'द्रुत कार्यहरू',
    createNewCustomer: 'नयाँ ग्राहक थप्नुहोस्',
    addNewLead: 'नयाँ अवसर थप्नुहोस्',
    generateQuotation: 'कोटेशन बनाउनुहोस्',
    updateInventory: 'इन्भेन्टरी अपडेट',
    activeProcesses: 'सक्रिय प्रक्रियाहरू',
    completedToday: 'आज सम्पन्न',
    pendingActions: 'बाँकी कार्यहरू',
    aiRecommendations: 'एआई सुझावहरू',

    // Vendors Hub
    vendorsTitle: 'विक्रेता तथा स्टोर हब',
    vendorsSub: 'सबै दर्ता भएका पसलहरू, उत्पादनहरू र पीओएसको केन्द्रीय व्यवस्थापन',
    registerNewVendor: 'नयाँ पसल दर्ता गर्नुहोस्',
    exportDirectoryCsv: 'डाइरेक्टरी निर्यात (CSV)',
    totalRegisteredVendors: 'दर्ता भएका पसलहरू',
    activeStores: 'सक्रिय पसलहरू',
    catalogedItems: 'कैटलग उत्पादनहरू',
    businessSectors: 'व्यापारिक क्षेत्रहरू',
    searchVendorsPlaceholder: 'पसलको नाम, मालिक, मोबाइल वा भ्याट नम्बरबाट खोज्नुहोस्...',
    allSectors: 'सबै क्षेत्रहरू',
    allStatuses: 'सबै स्थितिहरू',
    activeStatus: 'सक्रिय',
    suspendedStatus: 'निलम्बित',
    colStoreOwner: 'पसल र मालिक',
    colSectorTax: 'क्षेत्र र कर विवरण',
    colContact: 'सम्पर्क विवरण',
    colCatalog: 'कैटलग',
    colStatus: 'स्थिति',
    colActions: 'कार्यहरू',
    openStorePos: 'पीओएस खोल्नुहोस्',
    manageProducts: 'उत्पादन व्यवस्थापन',
    editStoreDetails: 'विवरण सम्पादन',
    resetPassword: 'पासवर्ड रिसेट',
    suspendStore: 'निलम्बन गर्नुहोस्',
    activateStore: 'सक्रिय गर्नुहोस्',
    deleteStore: 'हटाउनुहोस्',

    // Customers
    customersTitle: 'ग्राहक व्यवस्थापन',
    customersSub: 'ग्राहक प्रोफाइल र सम्पर्क विवरण व्यवस्थापन गर्नुहोस्',
    addCustomerBtn: '+ नयाँ ग्राहक',
    searchCustomersPlaceholder: 'नाम, कम्पनी वा इमेलबाट खोज्नुहोस्...',
    colCustomerName: 'ग्राहक / कम्पनीको नाम',
    colType: 'प्रकार',
    colContactPerson: 'सम्पर्क व्यक्ति',
    colEmail: 'इमेल',
    colPhone: 'फोन',
    colCreditLimit: 'क्रेडिट सीमा',
    colReliability: 'विश्वसनीयता',
    businessType: 'व्यापार',
    individualType: 'व्यक्तिगत',

    // Inventory
    invTitle: 'इन्भेन्टरी व्यवस्थापन',
    invSub: 'उत्पादन परिमाण, लागत, बिक्री मूल्य र आपूर्तिकर्ता ट्र्याक गर्नुहोस्',
    addItemBtn: '+ नयाँ वस्तु',
    bulkImportBtn: 'बल्क CSV आयात',
    bulkExportBtn: 'इन्भेन्टरी निर्यात',
    searchInvPlaceholder: 'नाम, बारकोड वा वर्गबाट खोज्नुहोस्...',
    colItemName: 'वस्तुको नाम',
    colSku: 'बारकोड / SKU',
    colCategory: 'वर्ग',
    colStock: 'स्टक परिमाण',
    colCostPrice: 'लागत मूल्य',
    colSellingPrice: 'बिक्री मूल्य',
    colMargin: 'मार्जिन',
    colSupplier: 'आपूर्तिकर्ता',
    inStock: 'स्टकमा छ',
    lowStock: 'कम स्टक',
    outOfStock: 'स्टक सकियो',

    // POS Categories
    catAll: 'सबै',
    catBeverages: 'पेय पदार्थ',
    catFood: 'खाना',
    catServices: 'सेवाहरू',
    catGeneral: 'सामान्य',

    // Payment & Store
    cardPayment: 'कार्ड / मादा (Card/Mada)',
    cashPayment: 'नगद (Cash)',
    vatShort: 'भ्याट (VAT)',
    crShort: 'सीआर (CR)',
    cashier: 'क्यासियर',
    registeredStoreDetails: 'दर्ता गरिएको स्टोर विवरण',
    ownerCashier: 'मालिक / क्यासियर',
    currencyLabel: 'मुद्रा',
    itemsUnit: 'वस्तुहरू',
    storeNameLabel: 'स्टोरको नाम',
    ownerNameLabel: 'मालिकको नाम',
    mobileLabel: 'मोबाइल',
    categoryLabel: 'श्रेणी',
    quickAddTooltip: 'तत्काल बिक्रीको लागि वस्तु थप्नुहोस्',
    bulkCsvTooltip: 'CSV वा एक्सेलबाट थोक आयात',
    storeProductsTooltip: 'स्टोर उत्पादनहरूको सूची व्यवस्थापन गर्नुहोस्',

    // Vendor Catalog
    vendorCatalogTitle: 'स्टोर उत्पादन र क्याटलग',
    vendorCatalogSub: 'क्यासियर स्क्रिनमा तुरुन्त देखाउनका लागि वस्तुहरू र मूल्यहरू व्यवस्थापन गर्नुहोस्',
    goToPosBtn: 'पीओएस क्यासियर खोल्नुहोस्',
    bulkCsvBtn: 'थोक आयात (CSV)',
    addNewProductBtn: 'नयाँ वस्तु',
    searchProductPlaceholder: 'नाम वा बारकोड / SKU बाट खोज्नुहोस्...',
    allCategoriesOpt: 'सबै वर्गहरू',
    displayedCount: 'देखाइएका वस्तुहरू',
    colVatPrice: 'मूल्य (भ्याट सहित)',
    noProductsInCatalog: 'कुनै वस्तु फेला परेन',
    addFirstProductPrompt: 'सुरु गर्न आफ्नो पहिलो वस्तु थप्नुहोस्',
    editProductModalTitle: 'वस्तुको विवरण सम्पादन गर्नुहोस्',
    saveChangesBtn: 'परिवर्तनहरू सुरक्षित गर्नुहोस्',
    cancelBtn: 'रद्द गर्नुहोस्',

    // Vendor Management Filters & Options
    activeOnly: 'सक्रिय मात्र',
    suspendedOnly: 'निलम्बित',
    whatsappTooltip: 'ह्वाट्सएप च्याट',
    launchPosBtn: 'पीओएस सुरु गर्नुहोस्',
    manageCatalogBtn: 'क्याटलग व्यवस्थापन',
    editStoreBtn: 'स्टोर विवरण सम्पादन',
    changePasswordBtn: 'पासवर्ड परिवर्तन',
    suspendStoreBtn: 'स्टोर निलम्बन गर्नुहोस्',
    activateStoreBtn: 'स्टोर सक्रिय गर्नुहोस्',
    deleteStoreBtn: 'स्टोर स्थायी रूपमा मेटाउनुहोस्',
    noVendorsFound: 'खोजी अनुसार कुनै स्टोर भेटिएन',
    noVendorsSub: 'नयाँ स्टोर थप्न वा फिल्टर खाली गर्न सक्नुहुन्छ',

    // Vendor Registration & Modal
    registerVendorTitle: 'नयाँ स्टोर दर्ता गर्नुहोस्',
    registerVendorSub: 'तत्काल खाता र ZATCA POS को साथ नयाँ स्टोर थप्नुहोस्',
    storeArabicName: 'स्टोरको नाम (अरबी)',
    ownerManagerName: 'मालिक / प्रबन्धकको नाम',
    mobileUsername: 'मोबाइल नम्बर (प्रयोगकर्ता नाम)',
    emailOptional: 'इमेल (वैकल्पिक)',
    initialPassword: 'सुरुवाती पासवर्ड',
    businessSector: 'व्यावसायिक क्षेत्र / वर्ग',
    vatNumber15: 'भ्याट नम्बर (१५ अंक)',
    crNumber: 'व्यावसायिक दर्ता नम्बर (CR)',
    saveRegisterVendor: 'स्टोर सुरक्षित र दर्ता गर्नुहोस्',
    editVendorTitle: 'स्टोर विवरण सम्पादन',
    editVendorSub: 'सम्पर्क, भ्याट र सीआर नम्बर अपडेट गर्नुहोस्',
    resetPasswordTitle: 'नयाँ पासवर्ड सेट गर्नुहोस्',
    newPasswordLabel: 'नयाँ पासवर्ड',
    updatePasswordBtn: 'पासवर्ड अपडेट गर्नुहोस्',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'द्रुत वस्तु थप्नुहोस्',
    quickAddSub: 'तत्काल बिक्रीको लागि वस्तु तुरुन्तै क्यासियरमा देखिनेछ',
    productArabicName: 'वस्तुको नाम (अरबी)',
    productEnglishName: 'वस्तुको नाम (अंग्रेजी)',
    priceVatIncl: 'मूल्य (भ्याट सहित)',
    barcodeOptional: 'बारकोड / SKU (वैकल्पिक)',
    productCategory: 'वर्ग',
    customCategoryOpt: '➕ नयाँ अनुकूलित वर्ग...',
    saveToPosBtn: 'सुरक्षित गरी पीओएसमा थप्नुहोस्',
    bulkImportTitle: 'थोक वस्तु आयात (CSV)',
    downloadSampleCsvBtn: 'नमुना CSV डाउनलोड गर्नुहोस्',
    pasteCsvOrExcel: 'धेरै वस्तुहरू एकैचोटि आयात गर्न CSV टाँस्नुहोस् वा Excel बाट प्रतिलिपि गर्नुहोस्',
    csvDataLabel: 'वस्तु डेटा (CSV ढाँचा)',
    uploadingProducts: 'वस्तुहरू अपलोड हुँदैछन्...',
    supportedColumnsTip: 'समर्थित स्तम्भहरू (१० पूर्ण वा ५ द्रुत स्तम्भहरू):',
    supportedColumnsList: '१. अरबी नाम • २. अंग्रेजी नाम • ३. बिक्री मूल्य • ४. लागत मूल्य • ५. वर्ग • ६. बारकोड • ७. स्टक • ८. एकाइ • ९. भ्याट % • १०. न्यूनतम सतर्कता',
    bulkImportTip: '💡 Excel बाट सिधै प्रतिलिपि-टाँस गर्नुहोस् वा तयार नमुना CSV डाउनलोड गर्नुहोस्।',
    importAllProductsNow: 'सबै वस्तुहरू अहिले आयात गर्नुहोस्',
    deleteProductConfirm: 'के तपाईं पक्का यो वस्तु मेटाउन चाहनुहुन्छ?',
    itemUnitPiece: 'थान (Pcs)',

    // Language setting label
    langSettingTitle: 'प्रणाली भाषा (सार्वभौमिक)',
    langSettingDesc: 'सबै स्क्रिन र पीओएसका लागि आफ्नो मनपर्ने भाषा छान्नुहोस्',

    // HR & Workforce
    hrTitle: "मानव संसाधन र कार्यबल व्यवस्थापन (HR)",
    hrSub: "प्रतिबन्धित ERP पहुँच, साउदी श्रम सम्झौता र GOSI, WPS पेरोल, र व्हाट्सएप स्वीकृति व्यवस्थापन गर्नुहोस्",
    hrKsaComplianceBadge: "साउदी श्रम कानून र WPS अनुरूप",
    manageWhatsAppApprovers: "व्हाट्सएप अनुमोदकहरू व्यवस्थापन गर्नुहोस्",
    addNewEmployee: "+ नयाँ कर्मचारी थप्नुहोस्",
    totalWorkforce: "कुल कर्मचारी संख्या",
    saudizationRate: "साउदीकरण (Nitaqat)",
    activeErpUsers: "सक्रिय ERP प्रयोगकर्ताहरू",
    pendingWhatsAppApprovals: "बाँकी व्हाट्सएप स्वीकृतिहरू",
    wageProtectionSystem: "पारिश्रमिक संरक्षण (WPS)",
    wpsMudadCompliant: "१००% SAMA / मुदद SIF तयार",
    tabEmployees: "👥 कर्मचारी निर्देशिका र ERP पहुँच",
    tabSalaryGosi: "💵 तलब र GOSI क्यालकुलेटर",
    tabWhatsApp: "व्हाट्सएप स्वीकृतिहरू",
    tabPayrollWps: "🏦 मासिक पेरोल र WPS (मुदद)",
    empNumber: "कर्मचारी #",
    employeeName: "कर्मचारीको नाम",
    nationalIdOrIqama: "राष्ट्रिय परिचयपत्र / इकामा",
    jobTitleAndDept: "पद र विभाग",
    bankAndIban: "बैंक र IBAN",
    erpAccessCol: "ERP पहुँच",
    approvalStatusCol: "स्वीकृतिको स्थिति",
    statusApprovedWhatsApp: "व्हाट्सएप मार्फत स्वीकृत",
    statusPendingWhatsApp: "व्हाट्सएप हस्ताक्षरको प्रतीक्षामा",
    statusRejected: "अस्वीकृत",
    saudiCitizen: "साउदी",
    expatriate: "प्रवासी",
    noAccess: "कुनै पहुँच छैन",
    modulesCount: "मोड्युलहरू",
    generateMonthlyPayroll: "मासिक पेरोल उत्पन्न गर्नुहोस्",
    submitWhatsAppApproval: "व्हाट्सएप स्वीकृतिको लागि पेश गर्नुहोस्",
    downloadSifMudad: "मुददको लागि SIF डाउनलोड गर्नुहोस्",
    basicSalary: "आधारभूत तलब",
    housingAllowance: "आवास भत्ता",
    transportAllowance: "यातायात भत्ता",
    otherAllowances: "अन्य भत्ताहरू",
    grossSalary: "कुल तलब",
    gosiSubjectWage: "GOSI अंशदायी तलब",
    employeeGosiDeduction: "कर्मचारी GOSI कटौती",
    netSalary: "बैंकमा भुक्तानी योग्य खुद तलब",
    employerGosiCost: "रोजगारदाताको GOSI योगदान",
    eosbMonthlyLiability: "सेवा समाप्ति उपदान (दफा ८४)",
    registeredStakeholders: "दर्ता गरिएका अनुमोदकहरू",
    addApprover: "+ अनुमोदक थप्नुहोस्",
    liveWhatsAppAuditTrail: "प्रत्यक्ष व्हाट्सएप स्वीकृति अडिट लग",
    simulateApproval: "स्वीकृति सिमुलेट गर्नुहोस्",
    simulateRejection: "अस्वीकार गर्नुहोस्",
    sendWhatsAppPing: "व्हाट्सएप चेतावनी पठाउनुहोस्",
    editPermissions: "ERP अनुमतिहरू कन्फिगर गर्नुहोस्",
    salaryContractAndGosi: "तलब सम्झौता र GOSI",
    saveAndSendWhatsApp: "बचत गर्नुहोस् र व्हाट्सएप स्वीकृतिको लागि अनुरोध गर्नुहोस्",
    selectEmployee: "कर्मचारी चयन गर्नुहोस्",
    standard25Pct: "मानक (२५%)",
    standard10Pct: "मानक (१०%)",
    effectiveDate: "लागू मिति",
    saveEmployee: "कर्मचारी बचत गर्नुहोस् र स्वीकृति रूट गर्नुहोस्",
    enableErpAccess: "कर्मचारीका लागि ERP पहुँच सक्षम गर्नुहोस्",
    assignedRole: "तोकिएको भूमिका",
    dataScope: "डेटा दृश्यताको दायरा",
    scopeOwnRecords: "आफ्नै रेकर्ड मात्र",
    scopeDeptRecords: "विभागको रेकर्ड मात्र",
    scopeAllOrgRecords: "संस्थाका सबै रेकर्डहरू",
    allowedModules: "अधिकृत प्रणाली मोड्युलहरू",
    wpsSifReady: "बैंक जम्माको लागि SAMA / मुदद SIF फाइल तयार छ",
    totalNetPayable: "कुल खुद बैंक भुक्तानी",
    eligibleEmployees: "योग्य कर्मचारीहरू",
    qiwaContractCol: "किवा सम्झौता",
    qiwaContractTitle: "किवा प्लेटफर्म सम्झौता प्रमाणीकरण",
    qiwaContractNumber: "किवा सम्झौता नम्बर (जस्तै QW-10829471)",
    qiwaContractStatus: "किवा सम्झौता स्थिति",
    qiwaAuthenticated: "प्रमाणीकृत र सक्रिय",
    qiwaPendingSignature: "कर्मचारी स्वीकृति बाँकी (Absher)",
    qiwaDraft: "मस्यौदा सम्झौता",
    qiwaUnlinked: "किवामा जोडिएको छैन",
    qiwaComplianceNotice: "किवा र मुदाद WPS अनुपालन सूचना",
    qiwaPreFlightWarningTitle: "किवा र मुदाद अनुपालन पूर्व-जाँच",
    qiwaPreFlightWarningDesc: "किवा प्लेटफर्ममा प्रमाणीकृत सम्झौता नभएका कर्मचारीहरू छन्। मुदादले स्वचालित रूपमा पेरोल फाइलहरू किवा प्रमाणीकृत सम्झौताहरूसँग जाँच गर्छ।",
    qiwaFullyCompliant: "१००% किवा र मुदाद WPS अनुरूप",
    qiwaFullyCompliantDesc: "सबै कर्मचारीहरूसँग सक्रिय, प्रमाणीकृत किवा सम्झौताहरू छन् र कुनै समस्या बिना मुदाद पेरोलका लागि योग्य छन्।",
  },

  tl: {
    // Brand
    brandTitle: 'Trading ERP System',
    brandSub: 'Kumpletong Cloud Sales, Imbentaryo at Invoicing Platform',

    // Navigation
    navDashboard: 'Dashboard',
    navCustomers: 'Mga Kostumer',
    navLeads: 'Mga Oportunidad (Leads)',
    navInventory: 'Imbentaryo at Produkto',
    navSuppliers: 'Mga Tagatustos (Suppliers)',
    navQuotations: 'Mga Presyo (Quotations)',
    navDeliveryNotes: 'Mga Tala sa Paghahatid',
    navInvoices: 'Mga Invoice at Pagsingil',
    navQuickPos: 'Mabilis na POS Cashier',
    navVendorsHub: 'Hub ng mga Tindahan (Vendors)',
    navAccounting: 'Pagtutuos at Pananalapi',
    navGovernance: 'Pamamahala ng Korporasyon',
    navProcurement: 'Pamimili at Suplay',
    navProfitSharing: 'Paghahati ng Kita',
    navProcessFlow: 'Daloy ng Proseso AI',
    navSettings: 'Mga Setting ng Sistema',
    navGlobalAdmin: 'Global Admin',

    // Header & User Menu
    userProfile: 'Profile',
    userSettings: 'Mga Setting',
    userLogout: 'Mag-logout',
    loggedOutTitle: 'Naka-logout Na',
    loggedOutDesc: 'Matagumpay kang naka-logout sa sistema',
    languageSelector: 'Wika',
    selectLanguage: 'Pumili ng Wika',
    activeVendor: 'Aktibong Tindahan',
    switchVendor: 'Palitan ang Tindahan',
    quickActionPos: 'Buksan ang POS',

    // Common Buttons & Actions
    search: 'Maghanap...',
    filter: 'I-filter',
    exportCsv: 'I-export ang CSV',
    addNew: '+ Magdagdag ng Bago',
    save: 'I-save',
    cancel: 'Kanselahin',
    delete: 'Burahin',
    edit: 'I-edit',
    view: 'Tingnan',
    actions: 'Mga Aksyon',
    status: 'Katayuan',
    active: 'Aktibo',
    inactive: 'Hindi Aktibo',
    total: 'Kabuuan',
    loading: 'Naglo-load...',
    back: 'Bumalik',
    confirm: 'Kumpirmahin',
    refresh: 'I-refresh',
    print: 'I-print',
    all: 'Lahat',

    // Currency
    currencySymbol: '\uE900',

    // Dashboard
    dashTitle: 'Pangunahing Dashboard',
    dashWelcome: 'Maligayang pagdating sa kumpletong Trading ERP',
    totalCustomers: 'Kabuuang Kostumer',
    activeLeads: 'Aktibong Leads',
    inventoryItems: 'Mga Item sa Imbentaryo',
    quotations: 'Mga Quotation',
    monthlyRevenue: 'Buwanang Kita',
    growthRate: 'Bilis ng Paglago',
    totalProfit: 'Kabuuang Tubo',
    pendingProfit: 'Nakabinbing Tubo',
    saudiSponsor: 'Saudi Sponsor',
    recentActivity: 'Kamakailang Aktibidad',
    quickActions: 'Mabilisang Aksyon',
    createNewCustomer: 'Gumawa ng Kostumer',
    addNewLead: 'Magdagdag ng Lead',
    generateQuotation: 'Gumawa ng Quotation',
    updateInventory: 'I-update ang Imbentaryo',
    activeProcesses: 'Aktibong Proseso',
    completedToday: 'Nakumpleto Ngayong Araw',
    pendingActions: 'Nakabinbing Aksyon',
    aiRecommendations: 'Mga Rekomendasyon ng AI',

    // Vendors Hub
    vendorsTitle: 'Hub ng mga Tindahan (Vendors)',
    vendorsSub: 'Sentral na hub para pamahalaan ang mga tindahan, produkto, at direktang pag-access sa POS',
    registerNewVendor: 'Magparehistro ng Bagong Tindahan',
    exportDirectoryCsv: 'I-export ang Direktoryo (CSV)',
    totalRegisteredVendors: 'Kabuuang Tindahan',
    activeStores: 'Aktibong Tindahan',
    catalogedItems: 'Mga Produkto sa Katalogo',
    businessSectors: 'Mga Sektor ng Negosyo',
    searchVendorsPlaceholder: 'Maghanap ayon sa pangalan, may-ari, mobile, CR, o VAT...',
    allSectors: 'Lahat ng Sektor',
    allStatuses: 'Lahat ng Katayuan',
    activeStatus: 'Aktibo',
    suspendedStatus: 'Suspendido',
    colStoreOwner: 'Tindahan at May-ari',
    colSectorTax: 'Sektor at Impormasyon sa Buwis',
    colContact: 'Impormasyon sa Pakikipag-ugnayan',
    colCatalog: 'Katalogo',
    colStatus: 'Katayuan',
    colActions: 'Mga Aksyon',
    openStorePos: 'Buksan ang POS ng Tindahan',
    manageProducts: 'Pamahalaan ang mga Produkto',
    editStoreDetails: 'I-edit ang Detalye',
    resetPassword: 'I-reset ang Password',
    suspendStore: 'Suspindihin ang Tindahan',
    activateStore: 'I-activate ang Tindahan',
    deleteStore: 'Burahin ang Tindahan',

    // Customers
    customersTitle: 'Pamamahala ng mga Kostumer',
    customersSub: 'Pamahalaan ang mga profile at impormasyon ng kostumer',
    addCustomerBtn: '+ Magdagdag ng Kostumer',
    searchCustomersPlaceholder: 'Maghanap ayon sa pangalan, kumpanya, o email...',
    colCustomerName: 'Pangalan ng Kostumer / Kumpanya',
    colType: 'Uri',
    colContactPerson: 'Taong Makokontak',
    colEmail: 'Email',
    colPhone: 'Telepono',
    colCreditLimit: 'Limitasyon sa Kredito',
    colReliability: 'Pagiging Maaasahan',
    businessType: 'Negosyo',
    individualType: 'Indibidwal',

    // Inventory
    invTitle: 'Pamamahala ng Imbentaryo',
    invSub: 'Subaybayan ang dami ng produkto, gastos, presyo, at mga supplier',
    addItemBtn: '+ Bagong Produkto',
    bulkImportBtn: 'Bulk CSV Import',
    bulkExportBtn: 'I-export ang Imbentaryo',
    searchInvPlaceholder: 'Maghanap ayon sa pangalan, SKU, barcode, o kategorya...',
    colItemName: 'Pangalan ng Produkto',
    colSku: 'Barcode / SKU',
    colCategory: 'Kategorya',
    colStock: 'Dami ng Stock',
    colCostPrice: 'Presyo ng Gastos',
    colSellingPrice: 'Presyo ng Pagbebenta',
    colMargin: 'Margin',
    colSupplier: 'Supplier',
    inStock: 'May Stock',
    lowStock: 'Mababang Stock',
    outOfStock: 'Walang Stock',

    // POS Categories
    catAll: 'Lahat',
    catBeverages: 'Mga Inumin',
    catFood: 'Pagkain',
    catServices: 'Mga Serbisyo',
    catGeneral: 'Pangkalahatan',

    // Payment & Store
    cardPayment: 'Card / Mada',
    cashPayment: 'Cash',
    vatShort: 'VAT',
    crShort: 'CR',
    cashier: 'Kaha / Cashier',
    registeredStoreDetails: 'Detalye ng Rehistradong Tindahan',
    ownerCashier: 'May-ari / Kaha',
    currencyLabel: 'Pera (Currency)',
    itemsUnit: 'Mga Item',
    storeNameLabel: 'Pangalan ng Tindahan',
    ownerNameLabel: 'May-ari',
    mobileLabel: 'Mobile',
    categoryLabel: 'Kategorya',
    quickAddTooltip: 'Mabilis na magdagdag ng produkto para sa benta',
    bulkCsvTooltip: 'Bultuhang pag-import gamit ang CSV o Excel',
    storeProductsTooltip: 'Pamahalaan ang katalogo ng mga produkto',

    // Vendor Catalog
    vendorCatalogTitle: 'Katalogo at Produkto ng Tindahan',
    vendorCatalogSub: 'Pamahalaan ang mga produkto at presyo upang agad lumabas sa POS cashier',
    goToPosBtn: 'Buksan ang POS Cashier',
    bulkCsvBtn: 'Bultuhang Pag-import (CSV)',
    addNewProductBtn: 'Bagong Produkto',
    searchProductPlaceholder: 'Maghanap gamit ang pangalan o barcode / SKU...',
    allCategoriesOpt: 'Lahat ng Kategorya',
    displayedCount: 'Ipinapakitang Produkto',
    colVatPrice: 'Presyo (Kasama ang VAT)',
    noProductsInCatalog: 'Walang nahanap na produkto',
    addFirstProductPrompt: 'Idagdag ang iyong unang produkto upang magsimula',
    editProductModalTitle: 'I-edit ang Detalye ng Produkto',
    saveChangesBtn: 'I-save ang mga Pagbabago',
    cancelBtn: 'Kanselahin',

    // Vendor Management Filters & Options
    activeOnly: 'Aktibo Lamang',
    suspendedOnly: 'Suspendido',
    whatsappTooltip: 'Mabilisang WhatsApp Chat',
    launchPosBtn: 'Buksan ang POS',
    manageCatalogBtn: 'Pamahalaan ang Katalogo',
    editStoreBtn: 'I-edit ang Detalye ng Tindahan',
    changePasswordBtn: 'Palitan ang Password',
    suspendStoreBtn: 'Isuspinde ang Tindahan',
    activateStoreBtn: 'I-activate ang Tindahan',
    deleteStoreBtn: 'Permanenteng Tanggalin ang Tindahan',
    noVendorsFound: 'Walang tindahang tumugma sa iyong paghahanap',
    noVendorsSub: 'Maaari kang magdagdag ng bago o i-clear ang mga filter',

    // Vendor Registration & Modal
    registerVendorTitle: 'Magrehistro ng Bagong Tindahan',
    registerVendorSub: 'Magdagdag ng vendor na may agarang account at ZATCA POS',
    storeArabicName: 'Pangalan ng Tindahan (Arabic)',
    ownerManagerName: 'Pangalan ng May-ari / Tagapamahala',
    mobileUsername: 'Numero ng Mobile (Username)',
    emailOptional: 'Email (Opsyonal)',
    initialPassword: 'Paunang Password',
    businessSector: 'Sektor ng Negosyo / Kategorya',
    vatNumber15: 'Numero ng VAT (15 digit)',
    crNumber: 'Numero ng Rehistrasyon sa Komersyo (CR)',
    saveRegisterVendor: 'I-save at Irehistro ang Tindahan',
    editVendorTitle: 'I-edit ang Detalye ng Tindahan',
    editVendorSub: 'I-update ang impormasyon sa pakikipag-ugnayan, VAT at CR',
    resetPasswordTitle: 'Magtakda ng Bagong Password',
    newPasswordLabel: 'Bagong Password',
    updatePasswordBtn: 'I-update ang Password',

    // Quick Add Modal & Bulk CSV Modal
    quickAddTitle: 'Mabilisang Pagdagdag ng Produkto',
    quickAddSub: 'Agad na lalabas ang produkto sa POS cashier para sa agarang benta',
    productArabicName: 'Pangalan ng Produkto (Arabic)',
    productEnglishName: 'Pangalan ng Produkto (English)',
    priceVatIncl: 'Presyo (Kasama ang VAT)',
    barcodeOptional: 'Barcode / SKU (Opsyonal)',
    productCategory: 'Kategorya',
    customCategoryOpt: '➕ Bagong Pasadyang Kategorya...',
    saveToPosBtn: 'I-save at Idagdag sa POS',
    bulkImportTitle: 'Bultuhang Pag-import ng Produkto (CSV)',
    downloadSampleCsvBtn: 'I-download ang Halimbawang CSV',
    pasteCsvOrExcel: 'I-paste ang mga linya ng CSV o kopyahin mula sa Excel upang mag-import ng maraming produkto',
    csvDataLabel: 'Datos ng Produkto (CSV format)',
    uploadingProducts: 'Kasalukuyang nag-a-upload ng mga produkto...',
    supportedColumnsTip: 'Mga Suportadong Hanay (10 kumpleto o 5 mabilisang hanay):',
    supportedColumnsList: '1. Pangalan sa Arabic • 2. Pangalan sa English • 3. Presyo ng Benta • 4. Gastos • 5. Kategorya • 6. Barcode • 7. Stock • 8. Yunit • 9. VAT % • 10. Alerto sa Stock',
    bulkImportTip: '💡 Sinusuportahan ang direktang kopyahin-at-i-paste mula sa Excel o pag-download ng handang halimbawang CSV.',
    importAllProductsNow: 'I-import ang Lahat ng Produkto Ngayon',
    deleteProductConfirm: 'Sigurado ka bang nais mong tanggalin ang produktong ito?',
    itemUnitPiece: 'Pcs',

    // Language setting label
    langSettingTitle: 'Wika ng Sistema (Universal)',
    langSettingDesc: 'Piliin ang nais na wika sa lahat ng mga screen ng ERP at POS',

    // HR & Workforce
    hrTitle: "HR at Pamamahala ng Sahod",
    hrSub: "Pamahalaan ang restricted ERP access, kontrata sa Saudi Labor at GOSI, WPS payroll, at pag-apruba sa WhatsApp",
    hrKsaComplianceBadge: "Sumusunod sa Batas ng Paggawa ng Saudi at WPS",
    manageWhatsAppApprovers: "Pamahalaan ang mga Approver sa WhatsApp",
    addNewEmployee: "+ Magdagdag ng Bagong Empleyado",
    totalWorkforce: "Kabuuang Empleyado",
    saudizationRate: "Saudization (Nitaqat)",
    activeErpUsers: "Aktibong Gumagamit ng ERP",
    pendingWhatsAppApprovals: "Nakabinbing Pag-apruba sa WhatsApp",
    wageProtectionSystem: "Proteksyon sa Sahod (WPS)",
    wpsMudadCompliant: "100% Handang SAMA / Mudad SIF",
    tabEmployees: "👥 Direktoryo ng Empleyado at ERP Access",
    tabSalaryGosi: "💵 Sahod at GOSI Calculator",
    tabWhatsApp: "Pag-apruba sa WhatsApp",
    tabPayrollWps: "🏦 Buwanang Sahod at WPS (Mudad)",
    empNumber: "Emp #",
    employeeName: "Pangalan ng Empleyado",
    nationalIdOrIqama: "National ID / Iqama",
    jobTitleAndDept: "Posisyon at Kagawaran",
    bankAndIban: "Bangko at IBAN",
    erpAccessCol: "ERP Access",
    approvalStatusCol: "Katayuan ng Pag-apruba",
    statusApprovedWhatsApp: "Naaprubahan sa WhatsApp",
    statusPendingWhatsApp: "Naghihintay ng Pag-apruba sa WhatsApp",
    statusRejected: "Tinanggihan",
    saudiCitizen: "Saudi",
    expatriate: "Dayuhan",
    noAccess: "Walang Access",
    modulesCount: "mga module",
    generateMonthlyPayroll: "Bumuo ng Buwanang Sahod",
    submitWhatsAppApproval: "Isumite para sa Pag-apruba sa WhatsApp",
    downloadSifMudad: "I-download ang SIF para sa Mudad",
    basicSalary: "Batayang Sahod",
    housingAllowance: "Allowance sa Pabahay",
    transportAllowance: "Allowance sa Transportasyon",
    otherAllowances: "Iba Pang Allowance",
    grossSalary: "Kabuuang Sahod",
    gosiSubjectWage: "GOSI Contributory Wage",
    employeeGosiDeduction: "Bawas sa GOSI ng Empleyado",
    netSalary: "Netong Sahod sa Bangko",
    employerGosiCost: "Kontribusyon ng Employer sa GOSI",
    eosbMonthlyLiability: "End of Service Accrual (Art. 84)",
    registeredStakeholders: "Mga Rehistradong Approver",
    addApprover: "+ Magdagdag ng Approver",
    liveWhatsAppAuditTrail: "Live WhatsApp Approval Audit Trail",
    simulateApproval: "Gayahin ang Pag-apruba",
    simulateRejection: "Tanggihan",
    sendWhatsAppPing: "Magpadala ng WhatsApp Alert",
    editPermissions: "Isaayos ang mga Pahintulot sa ERP",
    salaryContractAndGosi: "Kontrata sa Sahod at GOSI",
    saveAndSendWhatsApp: "I-save at Humiling ng Pag-apruba sa WhatsApp",
    selectEmployee: "Pumili ng Empleyado",
    standard25Pct: "Pamantayan (25%)",
    standard10Pct: "Pamantayan (10%)",
    effectiveDate: "Petsa ng Pagkakaroon ng Bisa",
    saveEmployee: "I-save ang Empleyado at Ipadala ang Pag-apruba",
    enableErpAccess: "Paganahin ang ERP Access para sa Empleyado",
    assignedRole: "Itinalagang Tungkulin",
    dataScope: "Saklaw ng Pagtingin sa Data",
    scopeOwnRecords: "Sariling Tala Lamang",
    scopeDeptRecords: "Tala ng Kagawaran Lamang",
    scopeAllOrgRecords: "Lahat ng Tala ng Organisasyon",
    allowedModules: "Mga Awtorisadong Module ng Sistema",
    wpsSifReady: "Handa ang Estruktura ng SAMA / Mudad SIF para sa Deposito sa Bangko",
    totalNetPayable: "Kabuuang Netong Bayad sa Bangko",
    eligibleEmployees: "Kwalipikadong Empleyado",
    qiwaContractCol: "Kontrata sa Qiwa",
    qiwaContractTitle: "Pagpapatotoo ng Kontrata sa Qiwa Platform",
    qiwaContractNumber: "Numero ng Kontrata sa Qiwa (hal. QW-10829471)",
    qiwaContractStatus: "Katayuan ng Kontrata sa Qiwa",
    qiwaAuthenticated: "Napatotohanan at Aktibo",
    qiwaPendingSignature: "Nakabinbin ang Pagtanggap ng Empleyado (Absher)",
    qiwaDraft: "Draft na Kontrata",
    qiwaUnlinked: "Hindi Nakakonekta sa Qiwa",
    qiwaComplianceNotice: "Paunawa sa Pagsunod sa Qiwa at Mudad WPS",
    qiwaPreFlightWarningTitle: "Pre-Flight Qiwa at Mudad Compliance Check",
    qiwaPreFlightWarningDesc: "May mga empleyado na walang napatotohanang kontrata sa Qiwa. Awtomatikong vine-verify ng Mudad ang payroll laban sa mga kontrata sa Qiwa.",
    qiwaFullyCompliant: "100% Sumusunod sa Qiwa at Mudad WPS",
    qiwaFullyCompliantDesc: "Lahat ng empleyado ay may aktibo at napatotohanang kontrata sa Qiwa at kwalipikado para sa pagsusumite sa Mudad WPS.",
  },
};
